import { calculateBundleItems, initializeBundlePrices } from '../../utils/bundlePricing';
import React, { useRef, useEffect } from 'react'
import { useRedirect } from 'react-admin'

import elrondApi from '../../api/elrond'
import {
    Box, Typography, BottomNavigation, BottomNavigationAction, Grid, Input, Button, Modal, RadioGroup, Radio, FormControlLabel, TableContainer, Table, TableHead, TextareaAutosize, Snackbar, Alert,
    TableBody, TableRow, Paper, MenuItem, TextField, Select, Switch, Chip, Divider
} from '@mui/material';
import globalStyles from '../../utils/globalStyles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { useForm, Controller } from 'react-hook-form';
import axios from 'axios';
import legolasApi from '../../api/legolas'
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { isEmpty, isUndefined, isNull, filter, size, minBy, floor, toUpper, set } from 'lodash';
import generateToken from '../../utils/generateToken'
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

let locationDataPromise;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#2b3f7a',
        color: theme.palette.common.white,
        padding: globalStyles.common.infoTablesPadding,
        borderRight: '2px solid #fff',
        whiteSpace: 'nowrap',
        minWidth: '50px'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: globalStyles.common.infoTablesPadding
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const OrderCreate = () => {
    const PAY_LATER_PAYMENT_ID = 8;
    const { state } = useLocation()
    const { handleSubmit, control, setValue, watch, reset } = useForm({
        defaultValues: {
            po_number: "",
            vat_number: "",
            id_label: "VAT / CR / Other Number",
            sales_person_name: '',
        }
    });
    const { id } = useParams()
    const navigate = useNavigate()
    const [data, setData] = React.useState([])
    const [Payment, setSelectedPayment] = React.useState({
        id: null,
        name: null,
        brand: null,
        txn_id: null,
        last4Digits: null
    });
    const [shipMethod, setShipMethod] = React.useState("freeshipping");
    const [boxHide, setboxHide] = React.useState(true);
    const [addressData, setAddressData] = React.useState({
        customer_firstname: "",
        customer_lastname: "",
        street: "",
        country: "Saudi Arabia",
        country_id: 1,
        country_code: "SA",
        city_id: "",
        city: "",
        district_id: '',
        district: "",
        postcode: "",
        phone_ext: "",
        phone: "",
        building_no: "",
        premisesCode: "",
        customer_unique_id: "",

    })
    const [reorderId, setReorderId] = React.useState('')
    const [orderHeaderData, setOrderHeaderData] = React.useState({
        po_number: '',
        vat_number: '',
        admin_order_source: 'Shababuna',
        websiteId: process.env.REACT_APP_SHABABUNA_CHANNEL_ID || 1, // default
        sales_person_name: '',
        // building_no: ''
    });

    const [orderAddressData, setOrderAddressData] = React.useState({});
    const [orderItemsData, setOrderItemsData] = React.useState([])
    const [orderPaymentData, setOrderPaymentData] = React.useState({});
    const [couponCode, setCouponCode] = React.useState('');
    const [orderRemarks, setOrderRemarks] = React.useState({});
    const [orderCartItems, setOrderCartItems] = React.useState([])
    const [customerData, setCustomerData] = React.useState({
        id: null,
        firstname: null,
        lastname: null,
        email: null,
        guest_user_email: null
    })
    const [summaryData, setSummaryData] = React.useState({
        subtotalInclTax: 0.00,
        shippingInclTax: 0.00,
        discountAmount: 0.00,
        codFeeInclTax: 0.00,
        fuel_charges: 0.00,
        tamaraProcessingFee: 0.00,
        tabbyProcessingFee: 0.00,
        taxAmount: 0.00,
        grandTotal: 0.00,
        delivery_method: '',
        one_day_delivery_charge: '0.00',
        delivery_method_price: '0.00',
        extra_discount: 0,
        extra_discount_amount: 0.00,
    });

    const [tamaraData, setTamaraData] = React.useState({});
    const [tabbyData, setTabbyData] = React.useState({});
    const [showTamara, setShowTamara] = React.useState(true);
    const [showTabby, setShowTabby] = React.useState(true);
    const [isTamaraActive, setIsTamaraActive] = React.useState(true);
    const [isTabbyActive, setIsTabbyActive] = React.useState(true);
    const [tamaraMinTotal, setTamaraMinTotal] = React.useState(0.00);
    const [tamaraMaxTotal, setTamaraMaxTotal] = React.useState(10000.00);
    const [tabbyMinTotal, setTabbyMinTotal] = React.useState(0.00);
    const [tabbyMaxTotal, setTabbyMaxTotal] = React.useState(2000.00);
    const [isTabbyEnabled, setIsTabbyEnabled] = React.useState(false);
    const [defaultCountryList, setDefaultCountryList] = React.useState([]);
    const [countryList, setCountryList] = React.useState([]);
    const [districtList, setDistrictList] = React.useState([])
    const [cityList, setCityList] = React.useState([])

    const [remarksString, setRemarksString] = React.useState('')
    const skuSearchInputRef = useRef(null);
    const oracleIdSearchInputRef = useRef(null);
    const [userSearchString, setUserSearchString] = React.useState('');
    const [searchedItems, setSearchedItems] = React.useState([]);
    const [itemsFound, setItemsFound] = React.useState(false);
    const [searchedUser, setSearchedUser] = React.useState([]);

    const [openAlert, setOpenAlert] = React.useState(false)
    const [alertText, setAlertText] = React.useState('')
    const [alertSuccess, setAlertSuccess] = React.useState('')
    const [openSuccess, setOpenSuccess] = React.useState(false)
    const [orderCoupon, setOrderCoupon] = React.useState('')
    const [couponApplied, setCouponApplied] = React.useState(false)
    const [orderAddressCountryCode, setOrderAddressCountryCode] = React.useState('SA')
    const [interntlShipCost, setInterntlShipCost] = React.useState(0.00)
    const [countryPhoneExt, setCountryPhoneExt] = React.useState('+966')
    const [phonePH, setPhonePH] = React.useState('5X XXX XXXX')
    const [countryExtCodes, setCountryExtCodes] = React.useState([
        { code: 'SA', id: 1, text: '+966', length: 9, start: ['5'], emoji: "🇸🇦", flag: '/static/content/flag-saudi.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00966|966|\\+966)', pHolder: '5X XXX XXXX' },
        { code: 'AE', id: 5, text: '+971', length: 9, start: ['5'], emoji: "🇦🇪", flag: '/static/content/flag-uae.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00971|971|\\+971)', pHolder: '5X XXX XXXX' },
        { code: 'BH', id: 2, text: '+973', length: 8, start: ['3'], emoji: "🇧🇭", flag: '/static/content/flag-baharain.png', regEx: '^(3)[0-9]{7}$', repExp: '^(00973|973|\\+973)', pHolder: '3X XXX XXX' },
        { code: 'OM', id: 4, text: '+968', length: 8, start: ['7', '9'], emoji: "🇴🇲", flag: '/static/content/flag-oman.png', regEx: '^(7|9)[0-9]{7}$', repExp: '^(00968|968|\\+968)', pHolder: '7X XXX XXX' },
        { code: 'KW', id: 3, text: '+965', length: 8, start: ['9', '5', '6'], emoji: "🇰🇼", flag: '/static/content/flag-kuwait.png', regEx: '^(9|5|6)[0-9]{7}$', repExp: '^(00965|965|\\+965)', pHolder: '9X XXX XXX' },
        //{ code: 'IN,', text: '+91', length: 10, start: ['6', '7', '8', '9'], emoji: "", flag: '/static/content/flag-india.png', regEx: '(6|7|8|9)[0-9]{9}$', repExp: '^(0091|91|\\+91)', pHolder: '9XXXX XXXXX'}
        { code: 'QA', id: 6, text: '+974', length: 8, start: ['3', '5', '9'], emoji: "", flag: '/static/content/flag-qatar.png', regEx: '^(3|5|9)[0-9]{7}$', repExp: '^(00974|974|\\+974)', pHolder: '3X XXX XXX' },
    ])
    const [customizePrice, setCustomizePrice] = React.useState(null);
    const [buttonClicked, setButtonClicked] = React.useState(false);
    const customizeData = [];
    const [focus, setFocus] = React.useState(false);
    const [customizePriceVisible, setCustomizePriceVisible] = React.useState(true);
    const hasCustomizePrice = customizePrice !== null && customizePrice !== undefined && String(customizePrice).trim() !== '';
    const isCustomizePriceInvalid = hasCustomizePrice && (!Number.isFinite(Number(customizePrice)) || Number(customizePrice) < 0);
    const [freeCod, setFreeCod] = React.useState('0.00');
    const [freeTamara, setFreeTamara] = React.useState('0');
    const [freeTabby, setFreeTabby] = React.useState('0');
    const [loading, setLoading] = React.useState(false);
    const [productsInBundle, setProductsInBundle] = React.useState([]);
    const [addShippingCharges, setAddShippingCharges] = React.useState(0.00);
    const [showInputBox, setShowInputBox] = React.useState(false);
    const [isEditingShipping, setIsEditingShipping] = React.useState(false); // Flag to keep the input box visible
    const [showShippingInput, setShowShippingInput] = React.useState(false);
    const [showInternationalShipping, setShowInternationalShipping] = React.useState(false);
    const [isTamaraVisible, setIsTamaraVisible] = React.useState(true); // To control Tamara visibility
    const [isTabbyVisible, setIsTabbyVisible] = React.useState(true);// To control Tabby visibility
    const [channel, setChannel] = React.useState('1'); // Default to Shababuna Website
    const [selectedUser, setSelectedUser] = React.useState(null);
    const [citySearch, setCitySearch] = React.useState("");
    const [districtSearch, setDistrictSearch] = React.useState("");
    const toNumber = (val) => { return Number(String(val ?? 0).replace(/,/g, '')) || 0; };
    const getCalculatedDiscount = (value) => {
        // The source order's coupon is not valid for a new reorder. A coupon
        // explicitly applied on the reorder is handled normally.
        return reorderId !== '' && !couponApplied ? 0 : toNumber(value);
    };
    const getItemPriceForCountry = (item, countryCode = orderAddressCountryCode) => {
        // Always calculate from an immutable Saudi VAT-inclusive base. `price_incl_tax`
        // is updated for the selected country below, so using it as the base repeatedly
        // removes VAT more than once when the country or cart changes.
        const basePriceInclTax = toNumber(item.base_price_incl_tax ?? item.price_incl_tax);
        return countryCode === 'SA' ? basePriceInclTax : basePriceInclTax / 1.15;
    };
    const [storesList, setStoresList] = React.useState([]);
    const [loadingStores, setLoadingStores] = React.useState(false);
    const [selectedStores, setSelectedStores] = React.useState(null);
    const [showStoresSelector, setShowStoresSelector] = React.useState(false);
    const [deliveryType, setDeliveryType] = React.useState("delivery");
    const [reorderDeliveryMethod, setReorderDeliveryMethod] = React.useState("");
    const isStoresPickup = deliveryType === "storepickup";
    const [nextDayDelivery, setNextDayDelivery] = React.useState("No");
    const DEFAULT_NEXT_DAY_CITIES = ["Riyadh", "Jeddah", "Makkah"];
    const [nextDayCities, setNextDayCities] = React.useState(DEFAULT_NEXT_DAY_CITIES);
    const [stockDialog, setStockDialog] = React.useState({
        open: false,
        success: false,
        mode: "storepickup",
        message: "",
        location: "",
        products: [],
        allocations: []
    });
    const [nddSelectedStores, setNddSelectedStores] = React.useState([]);
    const NEXT_DAY_DELIVERY_FEE = 30;
    const isStorePickupReorder = reorderId !== "" && reorderDeliveryMethod === "store_pickup";
    const isNextDayDeliveryReorder = reorderId !== "" && reorderDeliveryMethod === "next_day_delivery";
    const isNextDayCity = (city) => nextDayCities.some(
        item => item.toLowerCase() === String(city || '').trim().toLowerCase()
    );


const getStoreStockItems = (items = []) => {
    const quantities = new Map();

    items.forEach(item => {
       
        const productId =
            item.mageId ||
            item.mage_id ||
            item.productId ||
            item.sku ||
            item.item_sku;

        // Bundle parent should not be checked separately.
        if (!productId || item.referenceId || item.productType === "bundle") {
            return;
        }

        const qty = Number(
            item.qtyOrdered ??
            item.quantity ??
            item.qty ??
            0
        );

        if (!Number.isFinite(qty) || qty <= 0) {
            return;
        }

        const key = String(productId);

        const previous = quantities.get(key) || {
            productId: key,
            qty: 0,
            oracleId: item.oracleId || item.oracle_id || "",
            sku: item.sku || item.item_sku || ""
        };

        previous.qty += qty;

        if (!previous.oracleId && (item.oracleId || item.oracle_id)) {
            previous.oracleId = item.oracleId || item.oracle_id;
        }

        quantities.set(key, previous);
    });

    return Array.from(quantities.values());
};

const normalizeStoreAllocations = (allocations = []) => {
    if (!Array.isArray(allocations)) {
        return [];
    }

    return allocations
        .map(allocation => ({
            productId: allocation.productId
                ? String(allocation.productId)
                : "",

            oracleId: allocation.oracleId
                ? String(allocation.oracleId)
                : "",

            storeCode: allocation.storeCode
                ? String(allocation.storeCode)
                : "",

            selectedqty: Number(allocation.selectedqty || 0),

            productName: allocation.productName || "",

            nearestStore: Boolean(allocation.nearestStore)
        }))
        .filter(allocation =>
            allocation.storeCode &&
            allocation.selectedqty > 0 &&
            (allocation.productId || allocation.oracleId)
        );
};

const checkStoreStock = async ({
    nextDayDelivery = false,
    city = "",
    storeCode = "",
    items = []
}) => {
    try {
        const stockItems = getStoreStockItems(items);

        if (!stockItems.length) {
            return {
                success: false,
                message: "No valid products were found for store stock check.",
                errors: [],
                selectedStore: []
            };
        }

        const payload = {
            nextDayDelivery: Boolean(nextDayDelivery),
            operation: "check",
            ...(reorderId ? { parentOrderId: reorderId } : {}),
            items: stockItems
        };

        if (nextDayDelivery) {
            payload.city = String(city || "").trim();
        } else {
            payload.store_code = String(storeCode || "").trim();
        }

        console.log("validate-store-stock request:", payload);

        const response = await axios.post(
            //`${elrondApi.url}/hnak/check-store-stock`,
            `${legolasApi.url}/orders/validate-store-stock`,
            payload,
            {
                headers: {
                    channelid: websiteId,
                    locale: "en-SA",
                    "Content-Type": "application/json"
                }
            }
        );

        const data = response.data || {};
        const allocations = normalizeStoreAllocations(
            data.selectedStore || []
        );

        console.log("validate-store-stock response:", data);
        console.log("Normalized allocations:", allocations);

        return {
            ...data,
            selectedStore: allocations
        };
    } catch (error) {
        console.error("Store stock API error:", {
            status: error.response?.status,
            data: error.response?.data,
            message: error.message
        });

        return {
            success: false,
            message:
                error.response?.data?.message ||
                error.message ||
                "Unable to verify store stock.",
            errors: error.response?.data?.errors || [],
            selectedStore: []
        };
    }
};

const validateStoreStock = async (store, items) => {
    const storeCode = store?.storeCode;

    if (!storeCode) {
        return {
            success: false,
            message: "Please select a valid pickup store.",
            selectedStore: []
        };
    }

    return checkStoreStock({
        nextDayDelivery: false,
        storeCode,
        items
    });
};

const validateNextDayStock = async (city, items) => {
    if (!String(city || "").trim()) {
        return {
            success: false,
            message: "Please select a valid next-day-delivery city.",
            selectedStore: []
        };
    }

    return checkStoreStock({
        nextDayDelivery: true,
        city,
        items
    });
};



    const validateStorePickupStock = (storeCode, items) => {

        return checkStoreStock({
            nextDayDelivery: false,
            storeCode,
            items
        });

    };
   
    const getLocalizedProductName = (name) =>
        name?.["en-SA"] || name?.["ar-SA"] || name || "Product";

    const showStockDialog = (response, mode, location = "") => {
        let sourceProducts = response.success ? (response.stockInfo || []) : (response.errors || []);
        const stockCartItems = orderCartItems.filter(item => {
            const productId = item.sku || item.productId || item.mageId || item.mage_id;
            return productId && !item.referenceId && item.productType !== "bundle";
        });
        if (response.success && mode === "ndd") {
            const allocationProducts = new Map();
            (response.selectedStore || []).forEach(allocation => {
                const key = allocation.oracleId || getLocalizedProductName(allocation.productName);
                const existing = allocationProducts.get(key) || {
                    productId: key,
                    productName: allocation.productName,
                    requested: 0,
                    available: 0,
                    oracleId: allocation.oracleId
                };
                existing.requested += Number(allocation.selectedqty || 0);
                existing.available += Number(allocation.selectedqty || 0);
                allocationProducts.set(key, existing);
            });
            sourceProducts = Array.from(allocationProducts.values());
        }
        const products = sourceProducts.map((item, index) => {
            const productId = String(item.productId || "");
            const oracleId = String(item.oracleId || "");
            const matchingCartItem = orderCartItems.find(cartItem => {
                const cartProductId = String(cartItem.sku || cartItem.productId || cartItem.mageId || cartItem.mage_id || "");
                const cartOracleId = String(cartItem.oracleId || cartItem.oracle_id || "");
                return (productId && cartProductId === productId) || (oracleId && cartOracleId === oracleId);
            }) || stockCartItems[index];
            const alternatives = response.alternativeStores
                ?.find(alternative => alternative.productId === item.productId)
                ?.stores || [];
            return {
                productId: item.productId,
                name: getLocalizedProductName(item.productName || matchingCartItem?.productName || matchingCartItem?.name),
                requested: Number(item.requested || 0),
                available: Number(item.available ?? item.totalAvailableInCity ?? 0),
                oracleId: item.oracleId || matchingCartItem?.oracleId || matchingCartItem?.oracle_id || "",
                alternatives
            };
        });

        setStockDialog({
            open: true,
            success: Boolean(response.success),
            mode,
            message: response.message || "Stock check completed",
            location,
            products,
            allocations: response.selectedStore || []
        });
    };
   

    const canShowNextDay =
        deliveryType === "delivery" &&
        orderAddressCountryCode === "SA" &&
        isNextDayCity(addressData.city);

    const isB2BOrder =
        summaryData?.admin_order_source === "B2B" ||
        orderHeaderData?.admin_order_source === "B2B";

    React.useEffect(() => {
        if (!isB2BOrder) return;

        setDeliveryType("delivery");
        setNextDayDelivery("No");
        setSelectedStores(null);
        setShowStoresSelector(false);
        setNddSelectedStores([]);
        setSummaryData(prev => ({
            ...prev,
            delivery_method: "standard",
            one_day_delivery_charge: "0.00",
            delivery_method_price: "0.00"
        }));
        setOrderHeaderData(prev => ({
            ...prev,
            delivery_method: "standard",
            one_day_delivery_charge: "0.00",
            delivery_method_price: "0.00",
            shipping_method: "",
            store_id: "",
            store_name: "",
            store_details: null
        }));
    }, [isB2BOrder]);

    const getDeliveryMethodState = (selectedDeliveryType = deliveryType, nextDayValue = nextDayDelivery) => {
        if (selectedDeliveryType === "storepickup") {
            return "store_pickup";
        }
        if (nextDayValue === "Yes") {
            return "next_day_delivery";
        }
        return "standard";
    };

    const getDeliveryFeeValue = (selectedDeliveryType = deliveryType, nextDayValue = nextDayDelivery) => {
        return getDeliveryMethodState(selectedDeliveryType, nextDayValue) === "next_day_delivery"
            ? NEXT_DAY_DELIVERY_FEE
            : 0;
    };

    const syncDeliverySelection = (selectedDeliveryType, nextDayValue, store = null) => {

        const normalizedMethod = selectedDeliveryType === "storepickup" ? "store_pickup" : nextDayValue === "Yes" ? "next_day_delivery" : "standard";

        const deliveryFee = normalizedMethod === "next_day_delivery" ? NEXT_DAY_DELIVERY_FEE : 0;

        const summaryCountry = selectedDeliveryType === "storepickup" ? "SA" : orderAddressCountryCode;

        setDeliveryType(selectedDeliveryType);
        setNextDayDelivery(nextDayValue);

        if (selectedDeliveryType === "storepickup") {

            setShipMethod("freeshipping");

            setCountryPhoneExt("+966");
            setPhonePH("5X XXX XXXX");

            setOrderAddressCountryCode("SA");

            setAddressData(prev => ({
                ...prev,
                street: store?.address || store?.store_address || prev.street || "",
                city: store?.city || prev.city || "",
                city_id: store?.city_id || prev.city_id || 0,
                city_code: store?.city_code || prev.city_code || "",
                district: store?.district || prev.district || "",
                district_id: store?.district_id || prev.district_id || 0,
                district_code: store?.district_code || prev.district_code || "",
                country: "Saudi Arabia",
                country_code: "SA",
                country_id: store?.country_id || 1,
                phone_ext: "+966"
            }));
        }
        updateCartSummery(
            orderCartItems,
            summaryCountry,
            selectedDeliveryType,
            nextDayValue
        );

        setSummaryData(prev => ({
            ...prev,
            delivery_method: normalizedMethod,
            one_day_delivery_charge: deliveryFee.toFixed(2),
            delivery_method_price: deliveryFee.toFixed(2)
        }));

        setOrderHeaderData(prev => ({
            ...prev,
            delivery_method: normalizedMethod,
            one_day_delivery_charge: deliveryFee.toFixed(2),
            delivery_method_price: deliveryFee.toFixed(2),

            shipping_method:
                selectedDeliveryType === "storepickup"
                    ? "storepickup"
                    : "",

            store_id:
                selectedDeliveryType === "storepickup"
                    ? store?._id || ""
                    : "",

            store_name:
                selectedDeliveryType === "storepickup"
                    ? store?.name || ""
                    : "",

            store_details:
                selectedDeliveryType === "storepickup"
                    ? store
                    : null
        }));

        const country =
            selectedDeliveryType === "storepickup"
                ? "SA"
                : orderAddressCountryCode;

        // 
    };

    const websiteId = reorderId !== '' && orderHeaderData.channel_id
        ? orderHeaderData.channel_id
        : orderHeaderData.admin_order_source === "B2B"
            ? process.env.REACT_APP_B2B_CHANNEL_ID || "657979c059be05f5f8dd41f7"
            : process.env.REACT_APP_SHABABUNA_CHANNEL_ID || "657979c059be05f5f8dd41f6";

    const redirect = useRedirect();

    const handleAddNewUser = () => {
        const redirectUrl = '/users/add'
        redirect(redirectUrl)
    }

    const localStorageUser = localStorage.getItem('user');
    const user = JSON.parse(localStorageUser);
    const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];


    const getStoresList = async () => {
        try {
            setLoadingStores(true);
            const res = await axios.get(`${legolasApi.url}/admin/stores/pickupList`);
            if (res?.data?.success && res?.data?.data) {
                setStoresList(res.data.data.data);
            } else {
                setStoresList([]);
            }
        } catch (error) {
            console.log("Error loading pickup stores", error);
            setStoresList([]);
        } finally {
            setLoadingStores(false);

        }
    };

    const getNextDayCities = async () => {
        try {
            const res = await axios.get(`${legolasApi.url}/admin/stores/nddCities`);
            const cities = Array.isArray(res?.data?.data) ? res.data.data : [];
            const configuredCities = cities.map(city => city?.['en-SA']).filter(Boolean);
            if (configuredCities.length) {
                setNextDayCities(configuredCities);
            }
        } catch (error) {
            console.log('Error loading NDD cities', error);
        }
    };

    React.useEffect(() => {
        getNextDayCities();
    }, []);


    const resetOrderTotals = () => {
        setSummaryData(prev => ({
            ...prev,
            subtotalInclTax: 0,
            shippingInclTax: 0,
            discountAmount: 0,
            codFeeInclTax: 0,
            tamaraProcessingFee: 0,
            tabbyProcessingFee: 0,
            taxAmount: 0,
            grandTotal: 0,
            fuel_charges: 0,
            one_day_delivery_charge: 0,
            delivery_method_price: 0,
        }));

        setOrderHeaderData(prev => ({
            ...prev,
            subtotalInclTax: 0,
            shippingInclTax: 0,
            discountAmount: 0,
            codFeeInclTax: 0,
            tamaraProcessingFee: 0,
            tabbyProcessingFee: 0,
            totalTax: 0,
            grandTotal: 0,
            fuel_charges: 0,
            one_day_delivery_charge: 0,
            delivery_method_price: 0,
        }));
    };

    
    const getStockErrorMessage = (result) => {
        if (Array.isArray(result?.errors) && result.errors.length) {
            return result.errors.map(error => {
                const name = error.productName?.['en-SA'] || error.productName || error.productId || 'Product';
                const availability = `${error.available ?? error.totalAvailableInCity ?? 0}/${error.requested ?? 0} available`;
                const alternatives = result.alternativeStores
                    ?.find(item => item.productId === error.productId)
                    ?.stores?.map(store => `${store.storeName} (${store.available})`)
                    .join(', ');
                return `${name}: ${availability}${alternatives ? `. Available at ${alternatives}` : ''}`;
            }).join('\n');
        }
        return result?.message || 'Insufficient stock for the selected delivery option';
    };

    const normalizePickupStore = (store) => {
        if (typeof store === "string") {
            try {
                store = JSON.parse(store);
            } catch (error) {
                return null;
            }
        }
        if (!store || typeof store !== "object" || Array.isArray(store)) return null;

        const localizedValue = (value) => {
            if (value && typeof value === "object") {
                return value["en-SA"] || value["ar-SA"] || "";
            }
            return value || "";
        };
        const urls = Array.isArray(store.urls)
            ? store.urls.filter(url => typeof url === "string" && url.trim())
            : [];
        const localizedLink = localizedValue(store.link);
        const storeLocationUrl = store.store_location_url || urls[0] || localizedLink || "";

        return {
            ...store,
            _id: store._id || "",
            name: localizedValue(store.name) || store.store_name || "",
            store_name: store.store_name || localizedValue(store.name) || "",
            address: localizedValue(store.address) || store.store_address || "",
            store_address: store.store_address || localizedValue(store.address) || "",
            city: localizedValue(store.city),
            district: localizedValue(store.district),
            country: localizedValue(store.country),
            mobile: store.mobile || "",
            storeCode: store.storeCode || "",
            urls: storeLocationUrl && !urls.includes(storeLocationUrl)
                ? [storeLocationUrl, ...urls]
                : urls,
            link: {
                ...(store.link && typeof store.link === "object" ? store.link : {}),
                "en-SA": store.link?.["en-SA"] || storeLocationUrl,
                "ar-SA": store.link?.["ar-SA"] || storeLocationUrl
            },
            store_location_url: storeLocationUrl,
            timing: store.timing || [],
            country_code: store.country_code || "SA",
            country_id: store.country_id || 1,
            city_code: store.city_code || "",
            city_id: store.city_id || 0,
            district_code: store.district_code || "",
            district_id: store.district_id || 0,
        };
    };

    const handleStoreChange = async (event) => {
        const storeId = event.target.value;
        const store = storesList.find((item) => String(item._id) === String(storeId));
        if (!store) return;
        const formattedStore = normalizePickupStore(store);
        try {
            const stockResult = await validateStoreStock(formattedStore, orderCartItems);
            if (!stockResult.success) {
                showStockDialog(stockResult, "storepickup", formattedStore.name);
                return;
            }
            showStockDialog(stockResult, "storepickup", formattedStore.name);
        } catch (error) {
            handleAlertGen(error.response?.data?.message || 'Unable to verify store stock. Please try again.');
            return;
        }
        setSelectedStores(formattedStore);
        setShowStoresSelector(false);
        setSelectedPayment({ id: null, name: null, brand: null, txn_id: null, last4Digits: null });
        syncDeliverySelection("storepickup", "No", formattedStore);

    };

    const handleDeliveryTypeChange = (event) => {

        const value = event.target.value;

        if (
            (value === "delivery" && isStorePickupReorder) ||
            (value === "storepickup" && isNextDayDeliveryReorder)
        ) {
            return;
        }

        if (value === "storepickup") {

            if (storesList.length === 0 && !loadingStores) {
                getStoresList();
            }

            setShipMethod("freeshipping");

            setNextDayDelivery("No");

            setSelectedPayment({
                id: null,
                name: null,
                brand: null,
                txn_id: null,
                last4Digits: null
            });

            setShowStoresSelector(true);

            syncDeliverySelection("storepickup", "No");
            setOrderAddressCountryCode("SA");

            checkShippingConditions("SA", orderCartItems);
            updateCartSummery(orderCartItems, "SA");

        } else {

            setSelectedStores(null);

            setShowStoresSelector(false);

            const shipping =
                orderAddressCountryCode === "SA"
                    ? "freeshipping"
                    : "international";

            setShipMethod(shipping);

            syncDeliverySelection(
                "delivery",
                nextDayDelivery
            );
        }

    };


    const handleChangeStores = () => {
        setShowStoresSelector(true);
    };
  
    React.useEffect(() => {

        if (isStoresPickup && selectedUser) {

            const foundCountry =
                countryList?.find(
                    c =>
                        c.id == selectedUser.country_id ||
                        c.code == selectedUser.country_code
                ) || countryList?.find(c => c.code === "SA");

            const ext = countryExtCodes.find(
                ele => ele.code == foundCountry?.code
            );

            /* PHONE EXT */

            if (ext) {
                setCountryPhoneExt(ext.text);
                setPhonePH(ext.pHolder);
            }

            /* ONLY 6 FIELDS */

            const storePickupAddress = {

                customer_firstname:
                    (selectedUser.group_id == 2
                        ? selectedUser.firstnamear
                        : selectedUser.firstnamme) || "",

                customer_lastname:
                    (selectedUser.group_id == 2
                        ? selectedUser.lastnamear
                        : selectedUser.lastnamme) || "",


                country_code: "SA",
                country_id: 1,
                country: "Saudi Arabia",
                // phone_ext: "+966",
                // phone:
                //     selectedUser.phone || ""
                city: "",
                city_id: "",
                district: "",
                district_id: "",
                postcode: "",

                // Force Saudi phone extension
                phone_ext: "+966",

                // Keep only customer mobile number (without international prefix)
                phone: (selectedUser.phone || "").replace(
                    /^(00966|966|\+966|00971|971|\+971|00965|965|\+965|00973|973|\+973|00968|968|\+968|00974|974|\+974)/,
                    ""
                ),

                building_no: "",
                premisesCode: "",
            };


            /* ADDRESS */

            setAddressData((prev) => ({
                ...prev,
                ...storePickupAddress
            }));

            setOrderAddressData((prev) => ({
                ...prev,
                ...storePickupAddress
            }));

            /* FORM VALUES */

            setValue(
                "customer_firstname",
                storePickupAddress.customer_firstname
            );

            setValue(
                "customer_lastname",
                storePickupAddress.customer_lastname
            );

            setValue(
                "country_code",
                storePickupAddress.country_code
            );

            setValue(
                "phone_ext",
                storePickupAddress.phone_ext
            );

            setValue(
                "phone",
                storePickupAddress.phone
            );

            /* COUNTRY */

            setOrderAddressCountryCode("SA");

            setCountryPhoneExt("+966");
            setPhonePH("5X XXX XXXX");

            setShipMethod("freeshipping");

            setValue("country_code", "SA");
            setValue("phone_ext", "+966");

            setValue(
                "phone",
                (selectedUser.phone || "").replace(
                    /^(00966|966|\+966|00971|971|\+971|00965|965|\+965|00973|973|\+973|00968|968|\+968|00974|974|\+974)/,
                    ""
                )
            );

            // updateCartSummery(
            //     orderCartItems,
            //     "SA",
            //     "storepickup",
            //     "No"
            // );

            setOrderAddressCountryCode("SA");

            // Recalculate prices for Saudi
            checkShippingConditions("SA", orderCartItems);
            updateCartSummery(orderCartItems, "SA");
        }

    }, [
        isStoresPickup,
        selectedUser,
        countryList,
    ]);
    const resetAllStates = () => {
        // Reset dependent states when order source changes
        setAddressData({
            customer_firstname: "",
            customer_lastname: "",
            street: "",
            country: "Saudi Arabia",
            country_id: 1,
            country_code: "SA",
            city_id: "",
            city: "",
            district_id: "",
            district: "",
            postcode: "",
            phone_ext: "+966",
            phone: "",
            building_no: "",
            customer_unique_id: "",
        });
        setOrderAddressCountryCode('SA');
        checkShippingConditions('SA', []); // Add this line
        setAddressFormData(countryList, 'SA');
        updateCartSummery([], 'SA');
        setOrderCartItems([]);
        setSelectedUser(null);
        setSearchedUser([]);
        setOrderItemsData([]);
        if (skuSearchInputRef.current) skuSearchInputRef.current.value = '';
        if (oracleIdSearchInputRef.current) oracleIdSearchInputRef.current.value = '';
        setCouponCode([]);
        setCustomerData({});
        setRemarksString('');
        setSummaryData({
            subtotalInclTax: 0.00,
            shippingInclTax: 0.00,
            discountAmount: 0.00,
            codFeeInclTax: 0.00,
            fuel_charges: 0.00,
            tamaraProcessingFee: 0.00,
            tabbyProcessingFee: 0.00,
            taxAmount: 0.00,
            grandTotal: 0.00,
        });
        setSelectedPayment({
            id: null,
            name: null,
            brand: null,
            txn_id: null,
            last4Digits: null,
        });
        setCouponCode('');
        setOrderRemarks({});
        setSearchedItems([]);
        setSearchedUser([]);
        setUserSearchString([]);
        setItemsFound(false);
        setCustomizePrice();
        setShipMethod("freeshipping");
        setShowInputBox(false);
        //setOrderHeaderData({});
        setOrderRemarks('');


        // Clear order items
        setValue("customer_unique_id", "");
        prepareOrderData({}, 'order_header');
        setOrderHeaderData(prev => ({
            ...prev,
            notes: "",
            po_number: "",
            vat_number: "",
            admin_order_source: "",
            websiteId: orderHeaderData.admin_order_source === "B2B" ? process.env.REACT_APP_B2B_CHANNEL_ID : process.env.REACT_APP_SHABABUNA_CHANNEL_ID,
            sales_person_name: "",
            customer_unique_id: "",
            delivery_method: "standard",
            shipping_method: "",
            store_id: "",
            store_name: "",
            store_details: null

        }));

    }

    React.useEffect(() => {

        if (state) {
            const orderId = state.data;
            setReorderId(orderId);
            axios.get(`${legolasApi.url}/orders/${orderId}`).then((res) => {
                const reorderData = res.data.data;
                // Initialize from the saved order, independently of async reorderId state.
                (reorderData.items || []).forEach(item => {
                    if (item.product_type === 'bundle') {
                        item.bundleOrderedItems = initializeBundlePrices(
                            item.bundleOrderedItems || [],
                            reorderData.shipment.country_code || 'SA'
                        );
                    }
                });
                const inheritedCoupon = reorderData.summary.applied_rule_ids || reorderData.summary.coupon_code || '';
                const hasInheritedCoupon = Boolean(inheritedCoupon) && toNumber(reorderData.summary.discount_amount) > 0;
                setData(reorderData);
                setCouponCode(inheritedCoupon);
                setOrderCoupon(inheritedCoupon || null);
                setCouponApplied(hasInheritedCoupon);
                getAddressFormData(res.data.data.shipment.country_code);
                if (res.data.data && res.data.data.shipment.country_code != 'SA') {
                    setInterntlShipCost(parseFloat(res.data.data.summary.shipping_incl_tax));
                }

                if (res.data.data && res.data.data.shipment.country_code !== 'SA' && (!res.data.data.summary.shipping_incl_tax || parseFloat(res.data.data.summary.shipping_incl_tax) === 0)) {
                    const countryCode = res.data.data.shipment.country_code;
                    const totalWeight = res.data.data.summary.total_weight || 0;

                    axios.post(`${legolasApi.url}/admin/interntlshippingrates`, {
                        key: "country_id",
                        value: countryCode,
                        weight: totalWeight
                    }).then((shipRes) => {
                        if (shipRes.data && shipRes.data.data && shipRes.data.data.length > 0) {
                            const shipInfo = shipRes.data.data[0];
                            const shippingCost = parseFloat(shipInfo.shipping_price_final || 0);
                            const fuelCharges = parseFloat(shipInfo.fuel_charges || 0);

                            // Update summaryData dynamically
                            setSummaryData((prev) => ({
                                ...prev,
                                shippingInclTax: shippingCost.toFixed(2),
                                fuel_charges: fuelCharges.toFixed(2),
                                grandTotal: (
                                    parseFloat(prev.subtotalInclTax || 0) -
                                    parseFloat(prev.discountAmount || 0) +
                                    shippingCost +
                                    parseFloat(prev.codFeeInclTax || 0) +
                                    parseFloat(prev.tamaraProcessingFee || 0) +
                                    parseFloat(prev.tabbyProcessingFee || 0)
                                ).toFixed(2),
                            }));

                            setInterntlShipCost(shippingCost);
                        } else {
                            console.warn("No shipping data found for", countryCode);
                        }
                    }).catch((err) => {
                        console.error("Error fetching international shipping:", err.message);
                    });
                }
                setSummaryData({
                    subtotalInclTax: parseFloat(reorderData.summary.subtotal_incl_tax).toFixed(2),
                    shippingInclTax: parseFloat(reorderData.summary.shipping_incl_tax).toFixed(2),
                    discountAmount: parseFloat(reorderData.summary.discount_amount).toFixed(2),
                    codFeeInclTax: parseFloat(reorderData.summary.cod_fee_incl_tax).toFixed(2),
                    tamaraProcessingFee: parseFloat(reorderData.summary.tamara_fee_incl_tax).toFixed(2),
                    tabbyProcessingFee: parseFloat(reorderData.summary.tabby_fee_incl_tax).toFixed(2),
                    taxAmount: parseFloat(reorderData.summary.total_tax).toFixed(2),
                    grandTotal: parseFloat(reorderData.summary.grand_total).toFixed(2),
                    fuel_charges: parseFloat(reorderData.summary.fuel_charges).toFixed(2),
                    //admin_order_source: res.data.data.summary.admin_order_source,
                    admin_order_source: (typeof res.data.data.summary.admin_order_source === 'string' && res.data.data.summary.admin_order_source.trim() !== '') ? res.data.data.summary.admin_order_source : 'Frontend',
                    po_number: res.data.data.summary.po_number,
                    vat_number: res.data.data.summary.vat_number,
                    sales_person_name: res.data.data.summary.sales_person_name,
                    channel: res.data.data.summary.channel,
                    one_day_delivery_charge: parseFloat(
                        res.data.data.summary.one_day_delivery_charge
                        || res.data.data.summary.delivery_method_price
                        || 0
                    ).toFixed(2),
                    delivery_method: res.data.data.summary.delivery_method || '',
                    delivery_method_price: parseFloat(res.data.data.summary.delivery_method_price || 0).toFixed(2),
                    extra_discount: Number(reorderData.summary.extra_discount || 0),
                    extra_discount_amount: parseFloat(reorderData.summary.extra_discount_amount || 0).toFixed(2),

                });
                const existingDeliveryMethod = res.data.data.summary.delivery_method || "";
                setReorderDeliveryMethod(existingDeliveryMethod);
                if (existingDeliveryMethod === "store_pickup") {
                    getStoresList();
                    setDeliveryType("storepickup");
                    setNextDayDelivery("No");
                    const savedStore = res.data.data.summary.store_details || res.data.data.store_details;
                    if (savedStore) {
                        let parsedStore = savedStore;
                        if (typeof savedStore === "string") {
                            try {
                                parsedStore = JSON.parse(savedStore);
                            } catch (error) {
                                parsedStore = null;
                            }
                        }
                        setSelectedStores(normalizePickupStore(parsedStore));
                    }
                } else if (existingDeliveryMethod === "next_day_delivery") {
                    setDeliveryType("delivery");
                    setNextDayDelivery("Yes");
                } else {
                    setDeliveryType("delivery");
                    setNextDayDelivery("No");
                }
                setCustomizePriceVisible(true);
                const ext = countryExtCodes.find(ele => ele.code == res.data.data.shipment.country_code);
                if (ext) {
                    setCountryPhoneExt(ext.text);
                    setPhonePH(ext.pHolder);
                }
                setAddressData({
                    customer_firstname: res.data.data.shipment.customer_firstname,
                    customer_lastname: res.data.data.shipment.customer_lastname,
                    street: res.data.data.shipment.street,
                    building_no: res.data.data.shipment.building_no || '',
                    country: res.data.data.shipment.country,
                    country_id: ext.id ? ext.id : 'SA',
                    country_code: res.data.data.shipment.country_code,
                    city_id: (res.data.data.shipment.city_id) ? res.data.data.shipment.city_id : '0',
                    city: (res.data.data.shipment.city) ? res.data.data.shipment.city : '',
                    city_id_text: (res.data.data.shipment.city) ? res.data.data.shipment.city : '',
                    district_id_text: (res.data.data.shipment.district) ? res.data.data.shipment.district : '',
                    district_id: (res.data.data.shipment.district_id) ? res.data.data.shipment.district_id : '0',
                    district: (res.data.data.shipment.district) ? res.data.data.shipment.district : '',
                    postcode: res.data.data.shipment.postcode,
                    phone_ext: res.data.data.shipment.phone_ext,
                    phone: res.data.data.shipment.phone,
                    premisesCode: res.data.data.shipment.premisesCode || '',
                    customer_unique_id: res.data.data.shipment.customer_unique_id || '',



                });
                setCountryPhoneExt((res.data.data.shipment.phone_ext) ? res.data.data.shipment.phone_ext : '+966');
                setOrderAddressCountryCode((res.data.data.shipment.country_code) ? res.data.data.shipment.country_code : 'SA');

                setSelectedPayment({
                    ...Payment,
                    id: res.data.data.summary.fk_payment_id,
                    name: res.data.data.transaction.paymentType,
                    brand: res.data.data.transaction.paymentBrand,
                    txn_id: res.data.data.transaction?.otherData?.txn_id,
                    last4Digits: res.data.data.transaction.last4Digits
                })

                setFreeCod(parseFloat(res.data.data.summary.cod_fee_incl_tax).toFixed(2));
                setFreeTamara(
                    parseFloat(res.data.data.summary.tamara_fee_incl_tax).toFixed(2) > 0
                        ? parseFloat(res.data.data.summary.tamara_fee_incl_tax).toFixed(2)
                        : '0'
                );
                setFreeTabby(
                    parseFloat(res.data.data.summary.tabby_fee_incl_tax).toFixed(2) > 0
                        ? parseFloat(res.data.data.summary.tabby_fee_incl_tax).toFixed(2)
                        : '0'
                );
                setShipMethod(
                    res.data.data.shipment.country_code === 'SA' ?
                        (res.data.data.summary.shipping_incl_tax > 0 ? "shababuna" : "freeshipping") :
                        (res.data.data.summary.shipping_incl_tax > 0 ? "international" : "freeshipping")
                );
                prepareOrderData(reorderData, 'all', res.data.data.shipment.country_code || 'SA');

            }).catch((error) => {
                console.log("Error in order detail while checking invoice where order id is", orderId, error);
            });
        } else {
            let preOrderLoad = {};
            getAddressFormData('SA');
            prepareOrderData(preOrderLoad, 'all');

            setOrderPaymentData({
                ...orderPaymentData,
                txnAmount: parseFloat(0.00).toFixed(2),
                txnId: '',
                paymentStatus: 1,
                flagSaveCard: 0,
                flagClearCart: 0,
                responseInfo: "{}"
            })
        }

        const tamaraPayload = {
            "paymentId": 5,
            "countryId": 1
        };
        axios.post(`${legolasApi.url}/cart/tamarafee`, tamaraPayload).then((res) => {
            const tamaraCost = res.data.data;
            if (tamaraCost) {
                setTamaraData(tamaraCost);
                if (tamaraCost.active == 1 && tamaraCost.enable_payment_fee == 1) {
                    setIsTamaraActive(true);
                    setShowTamara(true);
                    let minCartTotal = parseFloat(tamaraCost.min_cart_total);
                    let maxCartTotal = parseFloat(tamaraCost.max_cart_total);

                    setTamaraMinTotal(minCartTotal);
                    setTamaraMaxTotal(maxCartTotal);
                }
            } else {
                setShowTamara(false);
            }

        }).catch((error) => console.log('Error in getting Tamara fee: ', error.message))


        const tabbyPayload = {
            "paymentId": 6,
            "countryId": 1
        };
        axios.post(`${legolasApi.url}/cart/tabbyfee`, tabbyPayload).then((res) => {
            const tabbyCost = res.data.data;
            if (tabbyCost) {
                setTabbyData(tabbyCost);
                if (tabbyCost.active == 1 && tabbyCost.enable_payment_fee == 1) {
                    setIsTabbyActive(true);
                    setShowTabby(true);
                    let minCartTotal = parseFloat(tabbyCost.min_cart_total);
                    let maxCartTotal = parseFloat(tabbyCost.max_cart_total);

                    setTabbyMinTotal(minCartTotal);
                    setTabbyMaxTotal(maxCartTotal);
                }
            } else {
                setShowTabby(false);
            }

        }).catch((error) => console.log('Error in getting Tabby fee: ', error.message))
    }, [])

    React.useEffect(() => {
        if (shipMethod) {
            let shippingCharge = 0;

            if (shipMethod === 'freeshipping') {
                shippingCharge = 0;
            } else if (shipMethod === 'shababuna') {
                shippingCharge = 23; // Fixed Shababuna shipping
            } else if (shipMethod === 'international') {
                shippingCharge = parseFloat(interntlShipCost || 0); // Use calculated international cost
            }

            // Call updateShippingCharges to recalc totals properly
            updateShippingCharges(shippingCharge, summaryData.tamaraProcessingFee, summaryData.one_day_delivery_charge);
        }
    }, [shipMethod, interntlShipCost,]);

    React.useEffect(() => {
        // if (!reorderId) return;

        setOrderHeaderData(prev => {
            const updates = {
                subtotalInclTax: summaryData.subtotalInclTax,
                shippingInclTax: summaryData.shippingInclTax,
                discountAmount: summaryData.discountAmount,
                codFeeInclTax: summaryData.codFeeInclTax,
                tamaraProcessingFee: summaryData.tamaraProcessingFee,
                tabbyProcessingFee: summaryData.tabbyProcessingFee,
                totalTax: summaryData.taxAmount,
                grandTotal: summaryData.grandTotal,
                one_day_delivery_charge: summaryData.one_day_delivery_charge,
                delivery_method: summaryData.delivery_method,
                delivery_method_price: summaryData.delivery_method_price,
                store_details: summaryData.delivery_method === "store_pickup" ? (prev.store_details || selectedStores) : null,
                store_id: summaryData.delivery_method === "store_pickup" ? (prev.store_id || selectedStores?._id || "") : "",
                store_name: summaryData.delivery_method === "store_pickup" ? (prev.store_name || selectedStores?.name || "") : "",
            };
            const hasChanges = Object.keys(updates).some(key => prev[key] !== updates[key]);
            return hasChanges ? { ...prev, ...updates } : prev;
        });
    }, [summaryData, reorderId, selectedStores]);

    const selectThisUser = (user) => {
        const idLabel =
            user.id_type === "VAT Number" ? "VAT Number" :
                user.id_type === "CR Number" ? "CR Number" :
                    user.id_type === "PO Number" ? "PO Number" :
                        user.id_type === "Other" ? "Other Number" :
                            "VAT / CR / Other Number";
        //console.log("Resolved idLabel:", idLabel);

        const poValue = user.id_type === "PO Number" ? user.id_value : "";
        const vatValue = user.id_type !== "PO Number" ? user.id_value : "";

        setValue("id_label", idLabel);
        setValue("po_number", poValue);
        setValue("vat_number", vatValue);

        setOrderHeaderData({
            ...orderHeaderData,
            customerId: user.id,
            po_number: poValue,
            vat_number: vatValue,
            id_label: idLabel
        });

        setSelectedUser(user);
        setCustomerData(user);
        setValue("customer_unique_id", user.customer_unique_id || "");
        // setOrderHeaderData({ ...orderHeaderData, customerId: user.id });

        if (user.country_id) {
            const foundCountry =
                countryList?.find(c => c.id == user.country_id || c.code == user.country_code)
                || countryList?.find(c => c.code === "SA")
                || {};

            const foundCity = foundCountry?.cities?.find(c => c.id == user.city_id) || {};
            const foundDist = foundCountry?.districts?.find(c => c.id == user.district_id) || {};
            setCityList(foundCountry.cities || []);
            setDistrictList(foundCountry.districts || []);
            const resolvedCountryCode = foundCountry.code || user.country_code
                || user.shippingCountryCode || user.billingCountryCode || "SA";
            const ext = countryExtCodes.find(ele => ele.code == resolvedCountryCode);
            if (ext) {
                setCountryPhoneExt(ext.text);
                setPhonePH(ext.pHolder);
            }

            let phoneExt = ext?.text || user.phone_ext || "+966";
            let phone = user.phone || "";

            // Agar backend ne phone me extension bhi bhej diya ho
            if (phone.startsWith("+")) {
                const matchedExt = countryExtCodes.find(c => phone.startsWith(c.text));

                if (matchedExt) {
                    phoneExt = matchedExt.text;
                    phone = phone.substring(matchedExt.text.length);
                }
            }
            const formattedAddress = {
                customer_firstname: (user.group_id == 2 ? user.firstnamear : user.firstnamme) || "",
                customer_lastname: (user.group_id == 2 ? user.lastnamear : user.lastnamme) || "",
                street: user.street || "",
                building_no: user.building_no || "",
                country_code: resolvedCountryCode,
                country_id: foundCountry.id || user.country_id || 1,
                country: foundCountry.value || user.country_name || "Saudi Arabia",
                city_id: foundCity.code || foundCity.id == 0 ? foundCity.id : "",
                city: foundCity.code || foundCity.id == 0 ? user.city : foundCity.value || "",
                city_id_text: user.city || "",
                district_id_text: user.district_name || "",
                district_id: user.district_id || user.district_id == 0 ? user.district_id : "",
                district: user.district_id || user.district_id == 0 ? user.district_name : foundDist?.value || "",
                postcode: user.postcode || "",
                //phone_ext: ext.text || user.phone_ext || "+966",
                //phone: user.phone || "",
                phone_ext: phoneExt,
                phone: phone,
                premisesCode: user.premisesCode || "",
                customer_unique_id: user.customer_unique_id || "",
                flagBilling: 1,

            };
            setAddressData((prev) => ({ ...prev, ...formattedAddress }));
            setOrderAddressData((prev) => ({ ...prev, ...formattedAddress }));
            setCountryPhoneExt(formattedAddress.phone_ext);
            setOrderAddressCountryCode(formattedAddress.country_code);
            if (formattedAddress.country_code != 'SA') {
                setShipMethod('international');

                let orderData = {
                    items: orderCartItems
                }

                updateCartSummery(orderCartItems, formattedAddress.country_code);

            } else {
                setShipMethod('freeshipping');

                let orderData = {
                    items: orderCartItems
                }
                updateCartSummery(orderCartItems, formattedAddress.country_code);
            }
            setTimeout(() => {
                setShipMethod(formattedAddress.country_code !== "SA" ? "international" : "freeshipping");
            }, 100);
        } else {
            const foundCountry = countryList.find((c) => c.id == (user.country_id || 'SA') || c.code == (user.country_id || 'SA'))
                || countryList.find(c => c.code === "SA")
                || {};
            const foundCity = foundCountry?.cities?.find(c => c.id == user.city_id) || {};
            const foundDist = foundCountry?.districts?.find(c => c.id == user.district_id) || {};
            const resolvedCountryCode = foundCountry.code || user.country_code
                || user.shippingCountryCode || user.billingCountryCode || "SA";
            const ext = countryExtCodes.find(ele => ele.code == resolvedCountryCode);
            if (ext) {
                setCountryPhoneExt(ext.text);
                setPhonePH(ext.pHolder);
            }
            let phoneExt = ext?.text || user.phone_ext || "+966";
            let phone = user.phone || "";

            if (phone.startsWith("+")) {
                const matchedExt = countryExtCodes.find(c => phone.startsWith(c.text));

                if (matchedExt) {
                    phoneExt = matchedExt.text;
                    phone = phone.substring(matchedExt.text.length);
                }
            }
            const formattedAddress = {
                customer_firstname: (user.group_id == 2 ? user.firstnamear : user.firstnamme) || "",
                customer_lastname: (user.group_id == 2 ? user.lastnamear : user.lastnamme) || "",
                street: user.street || "",
                building_no: user.building_no || "",

                // COUNTRY
                country_code: foundCountry?.code,
                country_id: foundCountry?.id,
                country: foundCountry?.value,

                // CITY (fixed)
                city_id: foundCity?.id || user.city_id || "",
                city: foundCity?.value || user.city || "",
                city_code: foundCity?.code || "",
                city_id_text: user.city || "",

                // DISTRICT (fixed)
                district_id: foundDist?.id || user.district_id || "",
                district: foundDist?.value || user.district_name || "",
                district_code: foundDist?.code || "",
                district_id_text: user.district_name || "",

                postcode: user.postcode || "",
                // phone_ext: user.phone_ext || "+966",
                // phone: user.phone || "",
                phone_ext: phoneExt,
                phone: phone,
                premisesCode: user.premisesCode || "",
                customer_unique_id: user.customer_unique_id || "",
                flagBilling: 1,
                country_code: resolvedCountryCode,
                country_id: foundCountry.id || user.country_id || 1,
                country: foundCountry.value || user.country_name || "Saudi Arabia",

            };
            setAddressData((prev) => ({ ...prev, ...formattedAddress }));
            setOrderAddressData((prev) => ({ ...prev, ...formattedAddress }));
            setCountryPhoneExt(formattedAddress.phone_ext);
            setOrderAddressCountryCode(formattedAddress.country_code);
            if (formattedAddress.country_code != 'SA') {
                setShipMethod('international');

                let orderData = {
                    items: orderCartItems
                }

                updateCartSummery(orderCartItems, formattedAddress.country_code);

            } else {
                setShipMethod('freeshipping');

                let orderData = {
                    items: orderCartItems
                }
                updateCartSummery(orderCartItems, formattedAddress.country_code);
            }

        }
    };

    useEffect(() => {
        if (!reorderId || !orderHeaderData) return;

        const idLabel =
            orderHeaderData.id_type === "VAT Number" ? "VAT Number" :
                orderHeaderData.id_type === "CR Number" ? "CR Number" :
                    orderHeaderData.id_type === "PO Number" ? "PO Number" :
                        orderHeaderData.id_type === "Other" ? "Other Number" :
                            "VAT / CR / Other Number";

        setValue("po_number", orderHeaderData.po_number || "");
        setValue("vat_number", orderHeaderData.vat_number || "");
        //setValue("sales_person_name", orderHeaderData.sales_person_name || "");

        setValue("id_label", idLabel);
    }, [
        reorderId,
        orderHeaderData.id_type,
        orderHeaderData.po_number,
        orderHeaderData.vat_number,
        setValue
    ]);

    useEffect(() => {
        let label = "VAT / CR / Other Number";

        if (orderHeaderData?.vat_number) {
            label = "VAT Number";
        }
        else if (orderHeaderData?.cr_number) {
            label = "CR Number";
        }
        else {
            label = "Other Number";
        }

        setValue("id_label", label);
    }, [
        orderHeaderData.vat_number,
        orderHeaderData.cr_number,
        setValue
    ]);


    useEffect(() => {
        if (!reorderId) return;
        if (!orderHeaderData || !orderHeaderData.sales_person_name) return;

        reset({
            sales_person_name: orderHeaderData.sales_person_name,
            po_number: orderHeaderData.po_number || '',
            vat_number: orderHeaderData.vat_number || '',
            id_label: orderHeaderData.id_label || '',
            admin_order_source: orderHeaderData.admin_order_source || 'Shababuna',
        });
    }, [reorderId, orderHeaderData?.sales_person_name]);


    const handleChangeform = (event) => {
        const { name, value } = event.target
        setAddressData({ ...addressData, [name]: value });
        let cityId = addressData.city_id;
        let districtId = addressData.district_id;
        let countryCode = addressData.country_code;
        let countryValue = addressData.country;
        let countryId = addressData.country_id;
        let cityValue = addressData.city;
        let city_code = addressData.city_code;
        let districtValue = addressData.district;
        let district_code = addressData.district_code;



        if (name == 'country_code') {
            countryCode = value;
            cityValue = '';
            city_code = '';
            cityId = '';
            districtValue = '';
            district_code = '';
            districtId = '';
            setAddressFormData(defaultCountryList, value);
            const foundCountry = defaultCountryList.find(country => country.code == value);
            countryValue = foundCountry?.value || addressData.country || value;
            countryId = foundCountry?.id || addressData.country_id || "";
            setAddressData(prev => ({
                ...prev,
                country: countryValue,
                country_id: countryId,
                country_code: value,
                city_id: '',
                city: '',
                city_id_text: '',
                district_id: '',
                district: '',
                district_id_text: "",

            }));

            setOrderAddressCountryCode(countryCode);
            if (countryCode !== "SA") {
                setNextDayDelivery("No");
                setNddSelectedStores([]);
            }
            checkShippingConditions(orderAddressCountryCode, orderCartItems); // Add this line


            const ext = countryExtCodes.find(ele => ele.code == countryCode);
            if (ext) {
                setAddressData(prev => ({
                    ...prev,
                    phone_ext: ext.text,
                    phoneExt: ext.text,
                }));
                setCountryPhoneExt(ext.text);
                setPhonePH(ext.pHolder);
            } else {
                setCountryPhoneExt('+966');
                setPhonePH('5X XXX XXXX');
            }
            if (countryCode != 'SA') {
                setShipMethod('international');

                let orderData = {
                    items: orderCartItems
                }

                updateCartSummery(orderCartItems, countryCode, "delivery", "No");

            } else {
                setShipMethod('freeshipping');

                let orderData = {
                    items: orderCartItems
                }
                updateCartSummery(orderCartItems, countryCode);
            }

        }

        if (name == 'city_id_text') {
            setAddressData({ ...addressData, city_id_text: value ? value : "", city: value ? value : "" })
            cityValue = "Others";
            city_code = 'other';
            cityId = '0';
        }
       
        if (name === 'city_id') {
            if (value !== '0') {
                const foundCity = cityList.find(city => city.id == value);
                if (foundCity) {
                    cityValue = foundCity.value;
                    city_code = foundCity.code;
                    cityId = foundCity.id;
                }
                setAddressData(prev => ({
                    ...prev,
                    [name]: value,
                    city: cityValue,
                    city_id_text: '',
                }));
            } else {
                cityValue = 'Others';
                city_code = 'other';
                cityId = '0';
                setAddressData(prev => ({
                    ...prev,
                    [name]: value,
                    city: '',
                    city_id_text: '',
                }));
            }

            if (!isNextDayCity(cityValue) && nextDayDelivery === "Yes") {
                syncDeliverySelection("delivery", "No");
            }

            const foundCountry = defaultCountryList.find(
                country => country.code == orderAddressCountryCode
            );
            if (foundCountry) {
                countryValue = foundCountry.value;
                countryId = foundCountry.id;
            }
        }


        if (name === 'district_id') {
            if (value !== '0') {
                const foundDistrict = districtList.find(district => district.id == value);
                if (foundDistrict) {
                    districtValue = foundDistrict.value;
                    district_code = foundDistrict.code;
                    districtId = foundDistrict.id;
                }
                // Clear manual district input
                setAddressData(prev => ({
                    ...prev,
                    [name]: value,
                    district: districtValue,
                    district_code: district_code,
                    district_id_text: ''
                }));
            } else {
                // "Others" selected
                setAddressData(prev => ({
                    ...prev,
                    [name]: value,
                    district: '',
                    district_code: '',
                    district_id_text: prev.district_id_text || ''
                }));
                districtValue = 'Others';
                district_code = 'other';
                districtId = '0';
            }
        }


        if (name == 'district_id_text') {

            setAddressData({ ...addressData, district_id_text: value ? value : "", district: value ? value : "" })
            districtValue = "Others";
            district_code = 'other';
            districtId = '0';
        }
    }


    const handleShippingMethodChange = (event) => {
        const selectedMethod = event.target.value;
        setShipMethod(selectedMethod);

        // Check conditions for Tamara and Tabby visibility
        if (selectedMethod === "shababuna" || selectedMethod === "international") {
            setIsTamaraVisible(true); // Hide Tamara for certain shipping methods
            setIsTabbyVisible(true);  // Hide Tabby for certain shipping methods
        } else {
            setIsTamaraVisible(true);  // Show Tamara
            setIsTabbyVisible(true);   // Show Tabby
        }

        // Logic for international shipping charges input
        if (selectedMethod === "international" && isNaN(parseFloat(summaryData.shippingInclTax))) {
            setShowInputBox(true);
            setIsEditingShipping(true);
        } else {
            setShowInputBox(false);
            setIsEditingShipping(false);
        }
    };

    const handlePayment = (event) => {
        const { name, value } = event.target
         const isPayLater = Number(value) === PAY_LATER_PAYMENT_ID;
        //const selectedFreeCod = event.freeCodValue ?? freeCod;
       setSelectedPayment({
        ...Payment,
        id: value,
        name: isPayLater ? "Pay Later" : Payment.name,
        brand: isPayLater ? "PAY_LATER" : Payment.brand
    });
        let codFee = 0.00;
        let codFeeInclTax = 0.00;
        let tamaraProcessingFee = 0.00;
        let tabbyProcessingFee = 0.00;
        const one_day_delivery_charge = getDeliveryFeeValue(deliveryType, nextDayDelivery);
        const fuelCharges = parseFloat(summaryData.fuel_charges) || 0.00;
        let totalTaxAmount = parseFloat(orderHeaderData.totalTax);
        let grandTotal = parseFloat(orderHeaderData.subtotalInclTax) + parseFloat(orderHeaderData.shippingInclTax) + one_day_delivery_charge - getCalculatedDiscount(orderHeaderData.discountAmount);
        let status = 1;
        if (isPayLater) {
            status = 1; // pending payment
        }
        if ((value != 1 && value != 5 && value != 6) || orderAddressCountryCode != 'SA') {

            status = 2;
            codFee = 0.00;
            codFeeInclTax = 0.00;
        } else {
            if (value == 1) {
                codFee = 10.43;
                codFeeInclTax = freeCod === '12.00' && reorderId !== '' ? 0.00 : 12.00;
                //codFeeInclTax = parseFloat(selectedFreeCod);
                grandTotal = grandTotal + codFeeInclTax;
            } else if (value == 5) {
                if (orderAddressCountryCode === 'SA') {

                    let totalOrderPrice = grandTotal;
                    if (event.tamaraFee > 0) {
                        if (tamaraData.fee_type === 'PERCENTAGE') {
                            let tamaraFeeValue = parseFloat(tamaraData.fee_value);
                            tamaraProcessingFee = parseFloat(totalOrderPrice * (tamaraFeeValue / 100));
                        } else {
                            tamaraProcessingFee = parseFloat(tamaraData.fee_value);
                        }
                    }

                    if (parseFloat(tamaraData.fee_value).toFixed(2) != '0.00' && reorderId != '') {
                        tamaraProcessingFee = parseFloat(event.tamaraFee);
                    }
                    else if (freeTamara !== "0" && reorderId !== '') {
                        tamaraProcessingFee = 0.00;
                    }
                    else {
                        if (tamaraData.fee_type === 'PERCENTAGE') {
                            let tamaraFeeValue = parseFloat(tamaraData.fee_value);
                            tamaraProcessingFee = parseFloat(totalOrderPrice * (tamaraFeeValue / 100));
                        } else {
                            tamaraProcessingFee = parseFloat(tamaraData.fee_value);
                        }
                    }
                    grandTotal = grandTotal + tamaraProcessingFee;
                }
            } else if (value === 6) {
                if (orderAddressCountryCode === 'SA') {

                    // Tabby Payment
                    let totalOrderPrice = grandTotal;
                    if (parseFloat(event.tabbyFee) > 0) {
                        if (tabbyData.fee_type === 'PERCENTAGE') {
                            let tabbyFeeValue = parseFloat(tabbyData.fee_value);
                            tabbyProcessingFee = parseFloat(totalOrderPrice * (tabbyFeeValue / 100));
                        } else {
                            tabbyProcessingFee = parseFloat(tabbyData.fee_value);
                        }
                    }
                    grandTotal = grandTotal + tabbyProcessingFee;
                }
            }
        }
        totalTaxAmount = parseFloat(grandTotal / (100 + 15) * 15);

        if (orderAddressCountryCode != 'SA') {
            totalTaxAmount = 0.00;
        }
        setSummaryData((prev) => ({
            ...prev,
            taxAmount: parseFloat(totalTaxAmount).toFixed(2),
            codFeeInclTax: parseFloat(codFeeInclTax).toFixed(2),
            tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
            tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
            fuel_charges: fuelCharges.toFixed(2),
            grandTotal: parseFloat(grandTotal).toFixed(2),
            one_day_delivery_charge: parseFloat(one_day_delivery_charge).toFixed(2),
            delivery_method: reorderId !== '' ? prev.delivery_method : orderHeaderData.delivery_method,
            delivery_method_price: reorderId !== '' ? parseFloat(prev.delivery_method_price || 0).toFixed(2) : parseFloat(orderHeaderData.delivery_method_price || 0).toFixed(2),
        }));
        setOrderHeaderData({
            ...orderHeaderData,
            //building_no: orderHeaderData.building_no || null,  // ✅ ensure it's passed
          paymentId: Number(value),
            status: status,
            codFee: parseFloat(codFee).toFixed(2),
            codFeeInclTax: parseFloat(codFeeInclTax).toFixed(2),
            tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
            tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
            totalTax: parseFloat(totalTaxAmount).toFixed(2),
            fuel_charges: fuelCharges.toFixed(2),
            grandTotal: parseFloat(grandTotal).toFixed(2),
            one_day_delivery_charge: parseFloat(one_day_delivery_charge).toFixed(2),
            delivery_method: reorderId !== '' ? summaryData.delivery_method : orderHeaderData.delivery_method,
            delivery_method_price: reorderId !== '' ? parseFloat(summaryData.delivery_method_price || 0).toFixed(2) : parseFloat(orderHeaderData.delivery_method_price || 0).toFixed(2),
            totalDue: parseFloat(grandTotal).toFixed(2),
            totalPaid: parseFloat(0.00).toFixed(2),
            totalRefunded: parseFloat(0.00).toFixed(2),
        });
        setOrderPaymentData({ ...orderPaymentData, txnAmount: parseFloat(grandTotal).toFixed(2) });

    }
    const handleFreeCodChange = (event) => {
        const value = event.target.value;

        setFreeCod(value);
        const simulatedEvent = { target: { name: "freecod", value: Payment.id } };
        handlePayment(simulatedEvent);
    };

    const handleFreeTamaraChange = (event) => {
        const value = event.target.value;
        //console.log("Selected Value:", value);

        const tamaraFee = value === "0" ? 0 : parseFloat(tamaraData?.fee_value || 0);

        setFreeTamara(value);

        const simulatedEvent = {
            target: { name: "freetamara", value: Payment.id },
            tamaraFee: tamaraFee,
        };

        handlePayment(simulatedEvent);
    };

    const updateShippingCharges = (shippingCharge, tamaraProcessingFee = summaryData.tamaraProcessingFee) => {

        const validTamaraProcessingFee = isNaN(parseFloat(tamaraProcessingFee)) ? 0 : parseFloat(tamaraProcessingFee);
        const validShippingCharge = isNaN(parseFloat(shippingCharge)) ? 0.00 : parseFloat(shippingCharge);
        const validShippingAmount = isNaN(parseFloat(interntlShipCost)) ? 0.00 : parseFloat(interntlShipCost);
        const validTabbyProcessingFee = isNaN(parseFloat(summaryData.tabbyProcessingFee)) ? 0.00 : parseFloat(summaryData.tabbyProcessingFee);

        const cartSubtotalInclTax = orderCartItems.reduce((total, item) => {
            if (item.is_gift_product === 1) return total;
            return total + (getItemPriceForCountry(item) * parseInt(item.quantity || 0));
        }, 0);
        const validSubtotal = orderCartItems.length > 0
            ? cartSubtotalInclTax
            : toNumber(summaryData?.subtotalInclTax);
        const validDiscount = getCalculatedDiscount(summaryData?.discountAmount);
        const validCodFee = isNaN(parseFloat(summaryData?.codFeeInclTax)) ? 0 : parseFloat(summaryData?.codFeeInclTax);
        //const validOneDayDeliveryCharge = reorderId !== '' ? (isNaN(parseFloat(summaryData?.one_day_delivery_charge))  ? 0 : parseFloat(summaryData.one_day_delivery_charge)) : 0;

        const validDeliveryFee =
            parseFloat(summaryData.delivery_method_price || 0);
        // Compute grand total based on updated values
        let updatedGrandTotal =
            validSubtotal +
            validShippingCharge + // Updated shippingInclTax
            parseFloat(summaryData.codFeeInclTax || 0) +
            validTabbyProcessingFee +
            validDeliveryFee +
            //parseFloat(summaryData.tamaraProcessingFee || 0) -
            validTamaraProcessingFee - // Use validated tamara fee
            validDiscount

        if (shipMethod === 'international' && isNaN(parseFloat(summaryData.shippingInclTax))) {
            updatedGrandTotal += validShippingAmount; // Include valid shippingAmount
        }

       
        setSummaryData(prev => ({
            ...prev,
            subtotalInclTax: validSubtotal.toFixed(2),
            shippingInclTax: validShippingCharge.toFixed(2),
            tamaraProcessingFee: validTamaraProcessingFee.toFixed(2),

            one_day_delivery_charge: prev.one_day_delivery_charge,
            delivery_method: prev.delivery_method,
            delivery_method_price: prev.delivery_method_price,

            grandTotal: updatedGrandTotal.toFixed(2),
        }));
       
        setOrderHeaderData(prev => ({
            ...prev,
            subtotalInclTax: validSubtotal.toFixed(2),
            shippingAmount: validShippingAmount.toFixed(2),
            shippingInclTax: validShippingCharge.toFixed(2),

            one_day_delivery_charge: summaryData.one_day_delivery_charge,
            delivery_method: summaryData.delivery_method,
            delivery_method_price: summaryData.delivery_method_price,

            grandTotal: updatedGrandTotal.toFixed(2),
        }));
    };



    const handleFreeTabbyChange = (event) => {
        const value = event.target.value;
        setFreeTabby(value);
        const simulatedEvent = { target: { name: "freetabby", value: Payment.id }, tabbyFee: value };
        handlePayment(simulatedEvent);

    };

    const handleShippingMethod = (event) => {
        const { value } = event.target;
        const oneDayDeliveryCharge = getDeliveryFeeValue(deliveryType, nextDayDelivery);
        const subtotalInclTax = toNumber(orderHeaderData.subtotalInclTax) || 0;
        //const discountAmount = toNumber(orderHeaderData.discountAmount) || 0;
        const discountAmount = getCalculatedDiscount(orderHeaderData?.discountAmount);
        const codFeeInclTax = toNumber(orderHeaderData.codFeeInclTax) || 0;

        let shippingInclTax = 0;
        let shippingAmount = 0;
        let tamaraProcessingFee = 0;
        let tabbyProcessingFee = 0;
        let totalTax = 0;
        let grandTotal = 0;


        let totalOrderPrice = subtotalInclTax - discountAmount + codFeeInclTax;
        const isFreeOrder = totalOrderPrice <= 0;


        if (!isFreeOrder) {
            if (value === 'freeshipping') {
                shippingInclTax = 0;
                shippingAmount = 0;
            }
            else if (value === 'shababuna') {
                shippingInclTax = 23.00;
                shippingAmount = 20.00;
            }
            else if (value === 'international') {
                shippingInclTax = toNumber(interntlShipCost) || 0;
                shippingAmount = shippingInclTax;
            }
        }

        //totalOrderPrice = subtotalInclTax - discountAmount + codFeeInclTax + shippingInclTax;
        totalOrderPrice = subtotalInclTax + codFeeInclTax + shippingInclTax + oneDayDeliveryCharge - discountAmount;
        grandTotal = totalOrderPrice;


        if (
            orderAddressCountryCode === 'SA' &&
            Payment?.id == 5 &&
            totalOrderPrice >= tamaraMinTotal &&
            totalOrderPrice <= tamaraMaxTotal
        ) {
            const feeValue = parseFloat(tamaraData?.fee_value) || 0;

            if (
                (feeValue === 0 && reorderId !== '') ||
                (freeTamara === "0" && reorderId !== '')
            ) {
                tamaraProcessingFee = 0;
            }
            else {
                if (tamaraData?.fee_type === 'PERCENTAGE') {
                    tamaraProcessingFee = totalOrderPrice * (feeValue / 100);
                } else {
                    tamaraProcessingFee = feeValue;
                }
            }

            grandTotal = totalOrderPrice + tamaraProcessingFee;
        }


        if (
            orderAddressCountryCode === 'SA' &&
            Payment?.id == 6 &&
            totalOrderPrice >= tabbyMinTotal &&
            totalOrderPrice <= tabbyMaxTotal
        ) {
            const feeValue = parseFloat(tabbyData?.fee_value) || 0;

            if (feeValue === 0 && reorderId !== '') {
                tabbyProcessingFee = 0;
            }
            else {
                if (tabbyData?.fee_type === 'PERCENTAGE') {
                    tabbyProcessingFee = totalOrderPrice * (feeValue / 100);
                } else {
                    tabbyProcessingFee = feeValue;
                }
            }

            grandTotal = totalOrderPrice + tabbyProcessingFee;
        }


        if (orderAddressCountryCode === 'SA') {
            totalTax = (grandTotal / 115) * 15;
        } else {
            totalTax = 0;
        }


        setOrderHeaderData(prev => ({
            ...prev,
            shippingInclTax: shippingInclTax.toFixed(2),
            shippingAmount: shippingAmount.toFixed(2),
            tamaraProcessingFee: tamaraProcessingFee.toFixed(2),
            tabbyProcessingFee: tabbyProcessingFee.toFixed(2),
            totalTax: totalTax.toFixed(2),
            fuel_charges: parseFloat(summaryData?.fuel_charges || 0).toFixed(2),
            //one_day_delivery_charge: parseFloat(summaryData?.one_day_delivery_charge || 0).toFixed(2),
            one_day_delivery_charge: prev.one_day_delivery_charge,
            delivery_method: prev.delivery_method,
            delivery_method_price: prev.delivery_method_price,
            grandTotal: grandTotal.toFixed(2),
            totalDue: grandTotal.toFixed(2),

        }));

        setSummaryData(prev => ({
            ...prev,
            shippingInclTax: shippingInclTax.toFixed(2),
            tamaraProcessingFee: tamaraProcessingFee.toFixed(2),
            tabbyProcessingFee: tabbyProcessingFee.toFixed(2),
            taxAmount: totalTax.toFixed(2),
            fuel_charges: parseFloat(prev?.fuel_charges || 0).toFixed(2),
            one_day_delivery_charge: parseFloat(prev?.one_day_delivery_charge || 0).toFixed(2),
            //delivery_method_price: prevdelivery_method_price,
            //delivery_method_price: prev.delivery_method_price,
            grandTotal: grandTotal.toFixed(2),
            delivery_method: prev.delivery_method,
            delivery_method_price: prev.delivery_method_price,
        }));

        setShipMethod(value);
    };


    const getAddressFormData = (defaultCountry) => {
        if (!locationDataPromise) {
            locationDataPromise = axios.get(`${elrondApi.url}/hnak/locationdata/${elrondApi.source}`).then(res => {
                let countries = [...res.data.data].sort((a, b) =>
                    a.name["en-SA"].localeCompare(b.name["en-SA"])
                );

                return countries.map(country => ({
                    ...country,
                    cities: country.cities ? [...country.cities].sort((a, b) =>
                        a.name["en-SA"].localeCompare(b.name["en-SA"])
                    ) : [],
                    districts: country.districts ? [...country.districts].sort((a, b) =>
                        a.name["en-SA"].localeCompare(b.name["en-SA"])
                    ) : []
                }));
            }).catch(error => {
                locationDataPromise = null;
                throw error;
            });
        }

        locationDataPromise.then(countries => {
            setDefaultCountryList(countries);
            setAddressFormData(countries, defaultCountry);
        }).catch((error) => {
            console.log("Error in load address data", error);
        });
    }

    const setAddressFormData = (countryList, defaultCountry) => {
        const foundCountry = countryList.find(country => country.code == defaultCountry)
        setCountryList(countryList);
        let defaultCityList = foundCountry?.cities
        let defaultDistrictList = foundCountry?.districts
        setCityList(defaultCityList);
        setDistrictList(defaultDistrictList);


    }

    const handleFocus = () => {
        setFocus(true);
    }

    const handleOutsideFocus = () => {
        setFocus(false);
    }

    const handleCustomizePrice = (e) => {
        setCustomizePrice(e.target.value);
    };




    const handleNotes = (e) => {
        const value = e.target.value;
        const source = orderHeaderData?.admin_order_source;
        setOrderHeaderData({ ...orderHeaderData, notes: source === "B2B" ? "B2B: " + value : source === "Shababuna" ? "Shababuna: " + value : value });
    };

    const handleSource = (value) => {
        //setAdminOrderSource(value);

        const mapping = {
            Shababuna: {
                label: "Shababuna",
                id: process.env.REACT_APP_SHABABUNA_CHANNEL_ID || "657979c059be05f5f8dd41f6",
            },
            B2B: {
                label: "B2B",
                id: process.env.REACT_APP_B2B_CHANNEL_ID || "657979c059be05f5f8dd41f7",
            },
        };

        const selected = mapping[value] || mapping["Shababuna"];

        if (orderHeaderData.admin_order_source !== selected.label) {
            resetAllStates();
        }
        setOrderHeaderData(prev => ({
            ...prev,
            admin_order_source: selected.label,
            websiteId: selected.id,
            channel_id: selected.id,
            notes: '',
        }));

        setSummaryData((prev) => ({
            ...prev,
            admin_order_source: selected.label,
        }));


        setCustomizePriceVisible(true);

        if (!isEmpty(orderCartItems)) {
            window.location.reload();
        }
    };




    const handlePurchaseOrder = (e) => {
        setOrderHeaderData({ ...orderHeaderData, po_number: e.target.value })
    }
    const handleVatNumber = (e) => {
        setOrderHeaderData({ ...orderHeaderData, vat_number: e.target.value })
    }
    const addProductToCart = (item) => {
        if (!(Number(item.quantity) - Number(item.on_hold_stock || 0) > 0)) {
            handleAlertGen('Product is not available in stock.');
            return;
        }
        if (customizePriceVisible && item.product_type !== 'bundle' && isCustomizePriceInvalid) return;
        const newPrice = customizePrice;
        let name = JSON.parse(item.product_name);
        let cartItems = orderCartItems;
        const foundCartItem = cartItems.find(cartItem => { if ((cartItem.oracle_id == item.oracle_id) && (cartItem.referenceId === null)) { return cartItem; } });
        if (foundCartItem) {
            return;
        }

        const isCustomizePriceValid = item.product_type !== 'bundle' && hasCustomizePrice && !isCustomizePriceInvalid;
        let customPrice = item.price_incl_tax;

        if (customizePriceVisible && isCustomizePriceValid) {
            const existingIndex = customizeData.findIndex(data => data.oracleid === item.oracle_id);

            if (existingIndex === -1) {
                customizeData.push({
                    oracleid: item.oracle_id,
                    custom_price: Number(newPrice)
                });

                customPrice = parseFloat(newPrice);

            } else {
                customPrice = parseFloat(customizeData[existingIndex].custom_price);
            }
            setCustomizePrice(null);
        }

        const finalCustomizePrice = customizePriceVisible && isCustomizePriceValid ? Number(newPrice) : parseFloat(item.price_incl_tax);


        let itemRecord = {
            item_id: item.item_id,
            mageId: item.mage_id,
            item_sku: item.item_sku,
            oracle_id: item.oracle_id,
            applied_rule_ids: (item.applied_rule_ids) ? item.applied_rule_ids : null,
            quantity: 1,
            qtyList: item.qtyList,
            totalQuantity: item.totalQuantity ?? item.quantity,
            on_hold_stock: item.on_hold_stock || 0,
            price: finalCustomizePrice,
            price_incl_tax: finalCustomizePrice,
            base_price_incl_tax: finalCustomizePrice,
            original_price: item.original_price,
            tax_amount: finalCustomizePrice / (100 + item.tax_percent) * item.tax_percent,
            tax_perc: item.tax_percent,
            discount: 0.00,
            discount_tax_amt: 0.00,
            discount_perc: 0,
            item_weight: item.weight,
            row_total: finalCustomizePrice * 1,
            row_total_incl_tax: finalCustomizePrice * 1,
            name: name["en-SA"],
            isCustom_price: customizePriceVisible && isCustomizePriceValid,
            referenceId: null,
            product_type: item.product_type,
            bundleOrderedItems: item.product_type === 'bundle'
                ? initializeBundlePrices(item.bundleOrderedItems || [])
                : item.bundleOrderedItems,
            giftProducts: item.giftProducts,
            is_gift_product: 0,
            gift_parent_id: null,
            gift_product_sku: null
        };

        cartItems.push(itemRecord);
        // if (!isEmpty(customizePrice)) {
        setButtonClicked(true);
        // }
        updateCartSummery(cartItems, orderAddressCountryCode);
    }

    const deleteProductFromCart = (item) => {
        let cartItems = orderCartItems;
        let afterRemoved = cartItems;
        const foundCartItem = cartItems.find(cartItem => cartItem.oracle_id == item.oracle_id)
        if (foundCartItem) { // only splice array when item is found
            afterRemoved = cartItems.filter(function (filterItem) {
                return filterItem.oracle_id !== foundCartItem.oracle_id;
            });
        }

        // Stock validation uses orderItemsData, while the cart table uses
        // orderCartItems. Keep both in sync immediately so a removed item is
        // never included in a stock request made before the summary finishes
        // recalculating.
        setOrderCartItems(afterRemoved);
        setOrderItemsData(currentItems => currentItems.filter(orderItem =>
            orderItem.oracleId !== item.oracle_id
        ));
        setNddSelectedStores([]);
        setStockDialog(currentDialog => ({ ...currentDialog, open: false }));

        updateCartSummery(afterRemoved, orderAddressCountryCode);
        setCustomizePrice(null);
        setButtonClicked(false);
    }

    const handleProductSearch = (e) => {
        if (reorderId && !orderHeaderData.channel_id) {
            handleAlertGen('Please wait for the original order to load before searching.');
            return;
        }
        setItemsFound(false);
        setSearchedItems([]);
        const searchValue = e === 'sku'
            ? String(skuSearchInputRef.current?.value || '').trim()
            : String(oracleIdSearchInputRef.current?.value || '').trim();

        if (!searchValue) {
            handleAlertGen('Please enter an Ecom ID, SKU, or Oracle ID.');
            return;
        }

        let searchQuery = {};
        if (e == 'sku') {
            searchQuery = {
                "key": "sku",
                "value": searchValue,
                "sku": searchValue
            };
        } else {
            searchQuery = {
                "key": "oracleId",
                "value": searchValue,
                "oracleId": searchValue
            };
        }
        if (reorderId) searchQuery.parentOrderId = reorderId;
        axios.post(`${legolasApi.url}/admin/products`, searchQuery, { headers: { channelid: websiteId } }).then((res) => {
            const item = res.data.data;
            if ((res.data.success === true || res.data.success === 'true') && item != null) {
                let itemName = JSON.parse(item.product_name);
                item.name = itemName["en-SA"];
                item.qtyList = [];
                for (let index = 0; index < parseInt(item.quantity); index++) {
                    item.qtyList.push(index + 1);
                }
                setButtonClicked(false);
                setItemsFound(true);
                setSearchedItems([item]);
            } else {
                setItemsFound(false);
                setSearchedItems([]);
                handleAlertGen(res.data.message || 'Product could not be added.');
            }

        }).catch((error) => {
            setItemsFound(false);
            setSearchedItems([]);
            console.log('Error in getting Product: ', error.message);
            handleAlertGen(error.response?.data?.message || 'Unable to search for the product.');
        })
    }

    const checkShippingConditions = (country, cartItems) => {
        const totalQuantity = cartItems.reduce(
            (sum, item) => sum + Number(item.quantity), // Ensure `quantity` is treated as a number
            0
        );
        if (country !== 'SA') {
            setShowInternationalShipping(true);

            if (totalQuantity > 60) {
                setShowShippingInput(true);
                updateShippingCharges(interntlShipCost);

            } else {
                setShowShippingInput(false);
            }
        } else {
            setShowInternationalShipping(false);
            setShowShippingInput(false);
        }
    };


    useEffect(() => {
        checkShippingConditions(orderAddressCountryCode, orderCartItems);
    }, [orderAddressCountryCode]); // Re-run whenever cart items or country changes

    const handleItemCartQty = (item, qty) => {
        let cartItems = orderCartItems;

        const foundCartItem = cartItems.find(cartItem => cartItem.oracle_id == item.oracle_id)

        if (foundCartItem) { // only splice array when item is found
            foundCartItem["quantity"] = qty;
            foundCartItem["row_total_incl_tax"] = qty * foundCartItem.price_incl_tax;
            foundCartItem["row_total"] = qty * foundCartItem.price;
            let taxPercent = foundCartItem["tax_perc"];
            foundCartItem["tax_amount"] = qty * (parseFloat(foundCartItem.price_incl_tax / (100 + taxPercent) * taxPercent));
        }
        updateCartSummery(cartItems, orderAddressCountryCode);
        checkShippingConditions(orderAddressCountryCode, cartItems); // Add this line

    }

    const calculateSATax = (price, taxPerc, countryCode) => {
        let taxAmount = 0;
        let basePrice = price;

        if (countryCode === 'SA' && taxPerc > 0) {
            basePrice = price / (1 + taxPerc / 100);
            taxAmount = price - basePrice;
        }

        return {
            basePrice: parseFloat(basePrice.toFixed(2)),
            taxAmount: parseFloat(taxAmount.toFixed(2))
        };
    };
    const updateCartSummery = async (cartItems, country_code = 'SA', deliveryTypeValue = deliveryType, nextDayValue = nextDayDelivery) => {
        let subtotal = 0.00;
        let subtotalInclTax = 0.00;
        let shippingInclTax = 0.00;
        let shippingAmount = 0.00;
        let discountAmount = 0.00;
        let discountTaxAmt = 0.00;
        let codFeeInclTax = 0.00;
        let codFee = 0.00;
        let tamaraProcessingFee = 0.00;
        let tabbyProcessingFee = 0.00;
        let fuel_charges = 0.00;
        let totalTaxAmount = 0;
        let grandTotal = 0;
        let totalQtyOrdered = 0;
        let totalItemCount = 0;
        let totalItemsWeight = 0;
        let totalBundleWeight = 0;

        let currentAddressCountryCode = country_code;
        let saudiTaxPercent = 15;
        let internationalTaxPercent = 0;


        const effectiveNextDayValue = currentAddressCountryCode === "SA"
            ? nextDayValue
            : "No";
        const oneDayDeliveryCharge = getDeliveryFeeValue(
            deliveryTypeValue,
            effectiveNextDayValue
        );
        if (reorderId != '') {
            codFeeInclTax = parseFloat(orderHeaderData.codFeeInclTax);
            codFee = parseFloat(orderHeaderData.codFee);
            // tamaraProcessingFee = parseFloat(orderHeaderData.tamaraProcessingFee);
            tamaraProcessingFee = freeTamara;
            tabbyProcessingFee = freeTabby;

        }


        cartItems.forEach(item => {
            const sell_price = getItemPriceForCountry(item, currentAddressCountryCode);
            item.applied_rule_ids = null;
            if (currentAddressCountryCode != 'SA') {
                item.price = sell_price;
                item.price_incl_tax = sell_price;
            } else {
                item.price = sell_price / 1.15;
                item.price_incl_tax = sell_price;
            }

            item.discount = item.is_gift_product === 1 ? sell_price : 0.00;
            item.discount_tax_amount = 0.00;

            subtotalInclTax = subtotalInclTax + (item.is_gift_product === 1 ? 0.00 : (parseFloat(sell_price) * parseInt(item.quantity)));

            subtotal = subtotal + (item.is_gift_product === 1 ? 0.00 : (parseFloat(item.price) * parseInt(item.quantity)));

            if (currentAddressCountryCode === 'SA') {
                const taxPerUnit = (parseFloat(sell_price) * 15) / 115;
                totalTaxAmount += taxPerUnit * item.quantity;
            }

            discountAmount = discountAmount + (item.is_gift_product === 1 ? 0.00 : parseFloat(item.discount));
            totalQtyOrdered = totalQtyOrdered + (item.is_gift_product === 1 ? 0 : parseInt(item.quantity));
            totalItemCount = totalItemCount + (item.is_gift_product === 1 ? 0 : 1);
            if (item.product_type !== 'bundle') {
                totalItemsWeight = totalItemsWeight + (item.item_weight * item.quantity);
            }
            if (item.product_type === 'bundle') {
                item.bundleOrderedItems.forEach((boi) => {
                    totalBundleWeight = totalBundleWeight + (boi.item_weight * (item.quantity * boi.bundleSingleItemQty));
                });
            }
        });
        totalItemsWeight = totalItemsWeight + totalBundleWeight;

        if (shipMethod == 'shababuna' && currentAddressCountryCode == 'SA') {
            shippingInclTax = 23.00;
            shippingAmount = 20.00;
            fuel_charges = 0.00;

        }
        if (currentAddressCountryCode != 'SA') {
            shippingInclTax = 0.00;
            shippingAmount = 0.00;
            codFeeInclTax = 0.00;
            tamaraProcessingFee = 0.00;
            tabbyProcessingFee = 0.00;
            codFee = 0.00;
            let reqPayload = {
                "key": "country_id",
                "value": currentAddressCountryCode,
                "weight": totalItemsWeight
            };
            axios.post(`${legolasApi.url}/admin/interntlshippingrates`, reqPayload).then((res) => {
                if (res.data.success) {
                    const shippingPrice = res.data.data[0];
                    let validShippingPrice = parseFloat(shippingPrice.shipping_price_final);
                    let validFuelCharges = parseFloat(shippingPrice?.fuel_charges);
                    validFuelCharges = isNaN(validFuelCharges) ? 0.00 : validFuelCharges;

                    if (isNaN(validShippingPrice)) {
                        validShippingPrice = 0.00; // Fallback to 0.00 if shipping_price is invalid
                    }
                    setInterntlShipCost(validShippingPrice);

                    // If the shipping method is 'international', we process shippingAmount and shippingInclTax
                    if (shipMethod === "international") {
                        shippingAmount = validShippingPrice.toFixed(2); // Use validShippingPrice for shippingAmount
                        shippingInclTax = shippingPrice.shipping_price_final
                            ;
                    }

                    // If addShippingCharges is provided, use it to override shippingAmount
                    if (addShippingCharges && !isNaN(parseFloat(addShippingCharges))) {
                        shippingAmount = parseFloat(addShippingCharges).toFixed(2);
                    }

                    grandTotal = subtotalInclTax + shippingInclTax + codFeeInclTax - discountAmount;
                    setSummaryData((prev) => ({
                        ...prev,
                        subtotalInclTax: parseFloat(subtotalInclTax).toFixed(2),
                        shippingInclTax: parseFloat(shippingInclTax).toFixed(2),
                        taxAmount: parseFloat(0.00).toFixed(2),
                        tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
                        tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
                        codFeeInclTax: parseFloat(codFeeInclTax).toFixed(2),
                        discountAmount: parseFloat(discountAmount).toFixed(2),
                        fuel_charges: validFuelCharges.toFixed(2), // Storing fuel charges
                        grandTotal: parseFloat(grandTotal).toFixed(2),
                        one_day_delivery_charge: oneDayDeliveryCharge.toFixed(2),
                        delivery_method: getDeliveryMethodState(deliveryTypeValue, effectiveNextDayValue),
                        delivery_method_price: oneDayDeliveryCharge.toFixed(2),
                    }));

                    setOrderHeaderData({
                        ...orderHeaderData,
                        subtotalInclTax: parseFloat(subtotalInclTax).toFixed(2),
                        shippingAmount: parseFloat(shippingAmount).toFixed(2),
                        shippingInclTax: parseFloat(shippingInclTax).toFixed(2),
                        totalTax: parseFloat(0.00).toFixed(2),
                        codFeeInclTax: parseFloat(codFeeInclTax).toFixed(2),
                        tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
                        tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
                        discountAmount: parseFloat(discountAmount).toFixed(2),
                        fuel_charges: validFuelCharges.toFixed(2), // Storing fuel charges
                        grandTotal: parseFloat(grandTotal).toFixed(2),
                        totalDue: parseFloat(grandTotal).toFixed(2),
                        oneDayDeliveryCharge: oneDayDeliveryCharge.toFixed(2),
                        one_day_delivery_charge: oneDayDeliveryCharge.toFixed(2),
                        delivery_method: getDeliveryMethodState(deliveryTypeValue, effectiveNextDayValue),
                        delivery_method_price: oneDayDeliveryCharge.toFixed(2)
                    })

                } else {
                    handleAlertGen(res.data.message)
                }

            }).catch((error) => console.log('Error in getting international shipping charges: ', error.message))

        }
        if (reorderId == '') {
            setSelectedPayment({ ...Payment, id: null });
        }

        if (
            currentAddressCountryCode == 'SA' &&
            (subtotalInclTax + shippingInclTax) >= tamaraMinTotal &&
            (subtotalInclTax + shippingInclTax) <= tamaraMaxTotal
        ) {

            if (Payment.id == 5 && reorderId != '' && freeTamara !== '0' && parseFloat(tamaraData.fee_value).toFixed(2) !== '0.00') {
                let totalOrderPrice = subtotalInclTax + shippingInclTax;
                if (tamaraData.fee_type == 'PERCENTAGE') {
                    let tamaraFeeValue = parseFloat(tamaraData.fee_value);
                    tamaraProcessingFee = parseFloat(totalOrderPrice * (tamaraFeeValue / 100));

                } else {
                    tamaraProcessingFee = parseFloat(tamaraData.fee_value);

                }
            } else {
                tamaraProcessingFee = 0.00;
            }
            setShowTamara(true);
            // tamaraFeeExclTax = tamaraProcessingFee - tamaraFeeTaxAmount;

        } else {
            setShowTamara(false);
            tamaraProcessingFee = 0.00;
        }
        // totalTaxAmount = totalTaxAmount + shippingTaxAmount + codTaxAmount;
        grandTotal = subtotalInclTax + shippingInclTax + codFeeInclTax + tamaraProcessingFee + oneDayDeliveryCharge - discountAmount;
        //totalTaxAmount = (grandTotal / (100 + saudiTaxPercent) * saudiTaxPercent);
        if (currentAddressCountryCode === 'SA') {
            totalTaxAmount = (grandTotal / (100 + saudiTaxPercent) * saudiTaxPercent);
        } else {
            totalTaxAmount = 0;
        }

        if (
            currentAddressCountryCode == 'SA' &&
            (subtotalInclTax + shippingInclTax) >= tabbyMinTotal &&
            (subtotalInclTax + shippingInclTax) <= tabbyMaxTotal
        ) {
            if (Payment.id == 6 && reorderId != '' && freeTabby !== '0' && parseFloat(tabbyData.fee_value).toFixed(2) !== '0.00') {
                let totalOrderPrice = subtotalInclTax + shippingInclTax;
                if (tabbyData.fee_type == 'PERCENTAGE') {
                    let tabbyFeeValue = parseFloat(tabbyData.fee_value);
                    tabbyProcessingFee = parseFloat(totalOrderPrice * (tabbyFeeValue / 100));
                } else {
                    tabbyProcessingFee = parseFloat(tabbyData.fee_value);
                }
            } else {
                tabbyProcessingFee = 0.00;
            }
            setShowTabby(true);
        } else {
            setShowTabby(false);
            tabbyProcessingFee = 0.00;
        }
        grandTotal = subtotalInclTax + shippingInclTax + codFeeInclTax + tabbyProcessingFee + oneDayDeliveryCharge - discountAmount;
        //totalTaxAmount = (grandTotal / (100 + saudiTaxPercent) * saudiTaxPercent);
        if (currentAddressCountryCode === 'SA') {
            totalTaxAmount = (grandTotal / (100 + saudiTaxPercent) * saudiTaxPercent);
        } else {
            totalTaxAmount = 0;
        }

        const sData = {
            subtotalInclTax: parseFloat(subtotalInclTax).toFixed(2),
            shippingInclTax: parseFloat(shippingInclTax).toFixed(2),
            discountAmount: parseFloat(discountAmount).toFixed(2),
            codFeeInclTax: parseFloat(codFeeInclTax).toFixed(2),
            tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
            tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
            taxAmount: parseFloat(totalTaxAmount).toFixed(2),
            grandTotal: parseFloat(grandTotal).toFixed(2),
            admin_order_source: summaryData.admin_order_source,
            one_day_delivery_charge: Number(getDeliveryFeeValue(deliveryTypeValue, effectiveNextDayValue)).toFixed(2),
            delivery_method: getDeliveryMethodState(deliveryTypeValue, effectiveNextDayValue),
            delivery_method_price: Number(getDeliveryFeeValue(deliveryTypeValue, effectiveNextDayValue)).toFixed(2),
        }
        setSummaryData((prev) => ({ ...prev, ...sData }));
        setOrderHeaderData({
            ...orderHeaderData,
            couponCode: '',
            appliedRuleIds: '',
            discountAmount: parseFloat(discountAmount).toFixed(2),
            discountTaxAmt: parseFloat(discountTaxAmt).toFixed(2),
            subtotal: parseFloat(subtotal).toFixed(2),
            subtotalInclTax: parseFloat(subtotalInclTax).toFixed(2),
            shippingAmount: parseFloat(shippingAmount).toFixed(2),
            shippingInclTax: parseFloat(shippingInclTax).toFixed(2),
            codFee: parseFloat(codFee).toFixed(2),
            codFeeInclTax: parseFloat(codFeeInclTax).toFixed(2),
            tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
            tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
            totalQtyOrdered: parseInt(totalQtyOrdered),
            totalTax: parseFloat(totalTaxAmount).toFixed(2),
            totalItemCount: parseInt(totalItemCount),
            grandTotal: parseFloat(grandTotal).toFixed(2),
            totalDue: parseFloat(grandTotal).toFixed(2),
            one_day_delivery_charge: Number(getDeliveryFeeValue(deliveryTypeValue, effectiveNextDayValue)).toFixed(2),
            oneDayDeliveryCharge: Number(getDeliveryFeeValue(deliveryTypeValue, effectiveNextDayValue)).toFixed(2),
            delivery_method: getDeliveryMethodState(deliveryTypeValue, effectiveNextDayValue),
            delivery_method_price: Number(getDeliveryFeeValue(deliveryTypeValue, effectiveNextDayValue)).toFixed(2),
        })

        setOrderPaymentData({ ...orderPaymentData, txnAmount: parseFloat(grandTotal).toFixed(2) });
        setCouponApplied(false);
        setOrderCoupon(null);

        let shippingMethod = 'freeshipping';
        if (parseInt(shippingInclTax) != 0) {
            shippingMethod = 'shababuna';
        }
        if (currentAddressCountryCode != 'SA' && interntlShipCost > 0) {
            shippingMethod = 'international';
        }

        setShipMethod(shippingMethod);

        let orderData = {
            items: cartItems
        }
        prepareOrderData(orderData, 'order_items', currentAddressCountryCode);
    }

    const handleApplyCoupon = (action) => {
        const currentCouponCode = String(
            action === 'remove' ? (orderCoupon || couponCode || '') : (couponCode || '')
        ).trim();
        let couponRemove = "0";
        if (action == 'add') {
            couponRemove = "0";
        } else {
            couponRemove = "1";
        }
        const filterOutGiftItem = filter(orderItemsData, (oid) => {
            return oid.is_gift_product !== 1
        });
        let payload = {
            remove: couponRemove,
            coupon_code: currentCouponCode,
            cartItems: filterOutGiftItem,
            cartSummary: orderHeaderData,
            countryCode: orderAddressCountryCode
        }

        if (currentCouponCode.length > 0) {
            axios.post(`${legolasApi.url}/coupon/admin/applycoupon`, payload).then((res) => {
                let result = res.data;
                let appliedDiscount = 0.00;
                let cartItems = orderCartItems;
                if (result.couponAction == 'applied' || result.couponAction == 'removed') {
                    let taxAmount = parseFloat(orderHeaderData.taxAmount);
                    let grandTotal = parseFloat(orderHeaderData.grandTotal);

                    //let couponSummery = result.summery;
                    let couponSummery = result.summery || {};
                    const finalDiscount = result.couponAction === "removed" ? 0 : parseFloat(couponSummery.discount_amount || 0);
                    const finalDiscountTax = result.couponAction === "removed" ? 0 : parseFloat(couponSummery.discount_tax_amount || 0);
                    if (result.couponAction == 'applied') {
                        let itemsList = result.cartItemsList;
                        setCouponApplied(true);
                        setOrderCoupon((couponSummery.applied_coupon_code) ? couponSummery.applied_coupon_code : null);
                        itemsList.forEach(item => {
                            // const foundCartItem = orderCartItems.find(orderItem => orderItem.oracleId == item.oracleId)
                            const foundCartItem = cartItems.find(cartItem => cartItem.oracle_id == item.oracleId)

                            if (foundCartItem) { // only splice array when item is found
                                let sell_price = parseFloat(item.priceInclTax);
                                if (orderAddressCountryCode != 'SA') {
                                    sell_price = parseFloat((parseFloat(item.price_incl_tax) * 100) / (100 + 15));
                                    item.discount_tax_amount = 0.00;
                                }
                                if (!isEmpty(customizePrice)) {
                                    sell_price = customizePrice;
                                }
                                foundCartItem["discount"] = item.is_gift_product === 1 ? sell_price : item.discount;
                                foundCartItem["discount_tax_amt"] = item.discount_tax_amount;
                                foundCartItem["discount_perc"] = parseFloat(item.discount_percent);
                                foundCartItem["applied_rule_ids"] = (couponSummery.applied_coupon_code) ? couponSummery.applied_coupon_code : null;

                                const subTotal = sell_price * parseInt(item.item_qty);
                                const itemDiscount = parseFloat(item.discount) * parseInt(item.item_qty);
                                const rowSubTotal = subTotal - itemDiscount;
                                foundCartItem["row_total_incl_tax"] = item.is_gift_product === 1 ? item.row_total_incl_tax : parseFloat(rowSubTotal).toFixed(2);
                                foundCartItem["row_total"] = item.is_gift_product === 1 ? item.row_total : parseFloat((parseFloat(item.price) - ((parseFloat(item.discount) - parseFloat(item.discount_tax_amount)))) * parseInt(item.item_qty)).toFixed(2);
                            }
                        });
                        appliedDiscount = parseFloat(couponSummery.discount_amount);
                        grandTotal = grandTotal - parseFloat(couponSummery.discount_amount);
                    } else {
                        setCouponApplied(false);
                        setOrderCoupon(null);
                        setCouponCode(null);
                        orderCartItems.forEach(item => {
                            item["discount"] = item.is_gift_product === 1 ? parseFloat(item.price_incl_tax) : 0.00;
                            item["discount_tax_amt"] = 0.00;
                            item["row_total_incl_tax"] = item.is_gift_product === 1 ? item.row_total_incl_tax : parseFloat(item.quantity * parseFloat(item.price_incl_tax)).toFixed(2);
                            item["row_total"] = item.is_gift_product === 1 ? item.row_total : parseFloat(item.quantity * parseFloat(item.price)).toFixed(2);

                        });
                        appliedDiscount = 0.00;
                        //grandTotal = grandTotal + parseFloat(orderHeaderData.discountAmount);
                        updateCartSummery(orderCartItems, orderAddressCountryCode);
                        return;
                    }

                    taxAmount = (grandTotal / (100 + 15) * 15);

                    if (orderAddressCountryCode != 'SA') {
                        taxAmount = 0.00;
                    }
                    let totalOrderPrice = (parseFloat(orderHeaderData.subtotalInclTax) + parseFloat(orderHeaderData.shippingInclTax) - appliedDiscount);
                    let tamaraProcessingFee = 0.00;
                    let tabbyProcessingFee = 0.00;
                    if (
                        orderAddressCountryCode == 'SA' &&
                        totalOrderPrice >= tamaraMinTotal &&
                        totalOrderPrice <= tamaraMaxTotal) {
                        setShowTamara(true);

                        if (Payment.id == 5) {

                            if (tamaraData.fee_type == 'PERCENTAGE') {
                                let tamaraFeeValue = parseFloat(tamaraData.fee_value);
                                tamaraProcessingFee = parseFloat(totalOrderPrice * (tamaraFeeValue / 100));

                            } else {
                                tamaraProcessingFee = parseFloat(tamaraData.fee_value);
                            }
                            grandTotal = totalOrderPrice + tamaraProcessingFee;
                            taxAmount = (grandTotal / (100 + 15) * 15);
                        }


                    } else {
                        setShowTamara(false);

                    }
                    if (isTabbyEnabled && totalOrderPrice >= tabbyMinTotal && totalOrderPrice <= tabbyMaxTotal) {
                        if (Payment.id === 6) { // Assuming Tabby Payment ID is 6
                            if (tabbyData.fee_type === 'PERCENTAGE') {
                                let tabbyFeeValue = parseFloat(tabbyData.fee_value);
                                tabbyProcessingFee = parseFloat(totalOrderPrice * (tabbyFeeValue / 100));
                            } else {
                                tabbyProcessingFee = parseFloat(tabbyData.fee_value);
                            }
                            grandTotal = totalOrderPrice + tabbyProcessingFee;
                            taxAmount = (grandTotal / (100 + 15) * 15);
                        }
                    }

                    setSummaryData((prev) => ({
                        ...prev,
                        discountAmount: finalDiscount.toFixed(2),
                        one_day_delivery_charge: prev.one_day_delivery_charge || prev.delivery_method_price || 0,
                        delivery_method: prev.delivery_method,
                        tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
                        tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
                        taxAmount: parseFloat(taxAmount).toFixed(2),
                        grandTotal: parseFloat(grandTotal).toFixed(2)
                    }));

                    setOrderHeaderData({
                        ...orderHeaderData,
                        couponCode: (couponSummery.applied_coupon_code) ? couponSummery.applied_coupon_code : null,
                        appliedRuleIds: (couponSummery.applied_coupon_code) ? couponSummery.applied_coupon_code : null,
                        //  discountAmount: parseFloat(couponSummery.discount_amount).toFixed(2),
                        discountAmount: finalDiscount.toFixed(2),

                        //discountTaxAmt: parseFloat(couponSummery.discount_tax_amount).toFixed(2),
                        discountTaxAmt: finalDiscountTax.toFixed(2),

                        tamaraProcessingFee: parseFloat(tamaraProcessingFee).toFixed(2),
                        tabbyProcessingFee: parseFloat(tabbyProcessingFee).toFixed(2),
                        totalTax: parseFloat(taxAmount).toFixed(2),
                        grandTotal: parseFloat(grandTotal).toFixed(2),
                        totalDue: parseFloat(grandTotal).toFixed(2),
                        one_day_delivery_charge:
                            reorderId !== ''
                                ? parseFloat(summaryData?.one_day_delivery_charge || 0).toFixed(2)
                                : '0.00',
                    })
                    setOrderPaymentData({ ...orderPaymentData, txnAmount: parseFloat(grandTotal).toFixed(2) });
                    let orderData = {
                        items: cartItems
                    }
                    prepareOrderData(orderData, 'order_items', orderAddressCountryCode);
                    handleAlertSuccess(result.message);
                } else {
                    handleAlertGen(result.message);
                }
            }).catch((error) => {
                handleAlertGen(error?.response?.data?.message || 'Unable to apply coupon. Please try again.');
            })
        } else {
            handleAlertGen('Please enter a coupon code.');
        }
    }

    const prepareOrderData = (orderData, type = 'all', countryCode = 'SA') => {
        if (orderData.customer && type == 'all') {
            setCustomerData((orderData.customer) ? orderData.customer : {
                id: null,
                firstname: null,
                lastname: null,
                email: null,
                guest_user_email: null
            });
        }

        if ((type == 'order_header' || type == 'all')) {
            setOrderCoupon((orderData.summary && orderData.summary.applied_rule_ids) ? orderData.summary.applied_rule_ids : null);
            setCouponCode((orderData.summary && orderData.summary.applied_rule_ids) ? orderData.summary.applied_rule_ids : null);
            setOrderHeaderData({
                couponCode: (orderData.summary) ? orderData.summary.applied_rule_ids : null,
                status: (orderData.summary && orderData.summary.fk_payment_id == 1) ? 1 : 2,
                discountAmount: (orderData.summary) ? parseFloat(orderData.summary.discount_amount).toFixed(2) : '0.00',
                discountTaxAmt: (orderData.summary) ? parseFloat(orderData.summary.discount_tax_amt).toFixed(2) : '0.00',
                grandTotal: (orderData.summary) ? parseFloat(orderData.summary.grand_total).toFixed(2) : '0.00',
                subtotal: (orderData.summary) ? parseFloat(orderData.summary.subtotal).toFixed(2) : '0.00',
                subtotalInclTax: (orderData.summary) ? parseFloat(orderData.summary.subtotal_incl_tax).toFixed(2) : '0.00',
                codFee: (orderData.summary) ? parseFloat(orderData.summary.cod_fee).toFixed(2) : '0.00',
                codFeeInclTax: (orderData.summary) ? parseFloat(orderData.summary.cod_fee_incl_tax).toFixed(2) : '0.00',
                shippingAmount: (orderData.summary) ? parseFloat(orderData.summary.shipping_amount).toFixed(2) : '0.00',
                shippingInclTax: (orderData.summary) ? parseFloat(orderData.summary.shipping_incl_tax).toFixed(2) : '0.00',
                tamaraProcessingFee: (orderData.summary) ? parseFloat(orderData.summary.tamara_fee_incl_tax).toFixed(2) : '0.00',
                tabbyProcessingFee: (orderData.summary) ? parseFloat(orderData.summary.tabby_fee_incl_tax).toFixed(2) : '0.00',
                totalQtyOrdered: (orderData.summary) ? parseFloat(orderData.summary.total_qty_ordered).toFixed(2) : '0',
                appliedRuleIds: (orderData.summary) ? orderData.summary.applied_rule_ids : null,
                totalTax: (orderData.summary) ? parseFloat(orderData.summary.total_tax).toFixed(2) : '0.00',
                totalItemCount: (orderData.summary) ? orderData.summary.total_item_count : '0',
                paymentId: (orderData.summary) ? orderData.summary.fk_payment_id : '1',
                shippingId: (orderData.summary) ? orderData.summary.shippingId : '1',
                orderSource: (orderData.summary) ? orderData.summary.order_src : '6',
                customerId: (orderData.summary) ? orderData.summary.customerId : null,
                storeId: (orderData.summary) ? orderData.summary.magento_store_id : '1',
                guestUserEmail: (orderData.summary) ? orderData.summary.guest_user_email : null,
                totalPaid: '0.00',
                totalDue: (orderData.summary) ? parseFloat(orderData.summary.grand_total).toFixed(2) : '0.00',
                totalRefunded: '0.00',
                admin_order_source: (orderData.summary && typeof orderData.summary.admin_order_source === 'string' && orderData.summary.admin_order_source.trim() !== '') ? orderData.summary.admin_order_source : (reorderId ? 'Frontend' : orderHeaderData.admin_order_source || 'Frontend'),
                channel_id: orderData.summary ? orderData.summary.channel_id : orderHeaderData.channel_id,
                po_number: (orderData.summary) ? orderData.summary.po_number : null,
                vat_number: (orderData.summary) ? orderData.summary.vat_number : null,
                sales_person_name: (orderData.summary) ? orderData.summary.sales_person_name : null,
                one_day_delivery_charge: reorderId !== '' && orderData.summary ? parseFloat(orderData.summary.one_day_delivery_charge || 0).toFixed(2) : '0.00',
                // building_no: (orderData.summary) ? orderData.summary.building_no : null
                delivery_method: reorderId !== '' && orderData.summary ? orderData.summary.delivery_method || '' : '',
                delivery_method_price: reorderId !== '' && orderData.summary ? parseFloat(orderData.summary.delivery_method_price || 0).toFixed(2) : '0.00',
            });
        }


        if ((type == 'order_address' || type == 'all')) {
            setOrderAddressData({
                flagBilling: '1',
                customerFirstname: (orderData.shipment) ? orderData.shipment.customer_firstname : null,
                customerLastname: (orderData.shipment) ? orderData.shipment.customer_lastname : null,
                postcode: (orderData.shipment) ? orderData.shipment.postcode : null,
                phone: (orderData.shipment) ? orderData.shipment.phone : null,
                phoneExt: (orderData.shipment) ? orderData.shipment.phone_ext : null,
                street: (orderData.shipment) ? orderData.shipment.street : null,
                district: (orderData.shipment) ? orderData.shipment.district : null,
                districtCode: (orderData.shipment) ? orderData.shipment.district : null,
                districtId: (orderData.shipment) ? orderData.shipment.district_id : null,
                city: (orderData.shipment) ? orderData.shipment.city : null,
                cityCode: (orderData.shipment) ? orderData.shipment.city : null,
                cityId: (orderData.shipment) ? orderData.shipment.city_id : null,
                country: (orderData.shipment) ? orderData.shipment.country : null,
                countryCode: (orderData.shipment) ? orderData.shipment.country_code : 'SA',
                countryId: (orderData.shipment) ? orderData.shipment.country_id : null,
                building_no: (orderData.shipment) ? orderData.shipment.building_no : null,
                premisesCode: (orderData.shipment) ? orderData.shipment.premisesCode : null,
                customer_unique_id: (orderData.shipment) ? orderData.shipment.customer_unique_id : null,


            })
        }
        if (orderData.transaction && (type == 'order_payment' || type == 'all')) {
            setOrderPaymentData({
                txnAmount: orderData.transaction.otherData?.txn_amt,
                txnId: orderData.transaction.otherData?.txn_id,
                paymentStatus: orderData.transaction.otherData?.payment_status,
                flagSaveCard: orderData.transaction.otherData?.flag_save_card,
                flagClearCart: 0,
                responseInfo: orderData.transaction.otherData?.response_json
            })
        }
        if (orderData.items && (type == 'order_items' || type == 'all')) {
            let filteredData = [];
            orderData.items.forEach(item => {
                if (!Number.isFinite(Number(item.base_price_incl_tax))) {
                    const currentPrice = toNumber(item.price_incl_tax ?? item.price);
                    item.base_price_incl_tax = countryCode === 'SA'
                        ? currentPrice
                        : currentPrice * 1.15;
                }
                const quantity = getApplicableBundleQuantity(item.product_type, item.bundleOrderedItems, item.totalQuantity);

                if (isUndefined(item.qtyList)) {
                    item.qtyList = [];
                    for (let index = 0; index < parseInt(quantity); index++) {
                        item.qtyList.push(index + 1);
                    }
                }
                filteredData.push(item);
            });
            setOrderCartItems(filteredData);
            let orderItems = [];
            let items = orderData.items;
            let itemInc = 0;

            items.forEach(item => {
                let sell_price = item.price_incl_tax;

                const itemQty = parseInt(item.quantity || item.item_qty || 0);
                const taxRate = countryCode === 'SA' ? 15 : 0;

                const rawPrice = parseFloat(item.price || 0);
                const rawPriceInclTax = parseFloat(item.price_incl_tax || 0);

                let priceExclTax;
                let priceInclTax;
                let rowTaxAmount = 0;

                if (countryCode === 'SA') {

                    const isTaxIncluded = Math.abs(rawPrice - rawPriceInclTax) < 0.0001;

                    if (isTaxIncluded) {
                        priceInclTax = rawPrice;
                        priceExclTax = (priceInclTax * 100) / (100 + taxRate);
                    } else {
                        priceExclTax = rawPrice;
                        priceInclTax = rawPriceInclTax;
                    }

                    const taxAmountPerUnit = priceInclTax - priceExclTax;
                    rowTaxAmount = taxAmountPerUnit * itemQty;

                } else {
                    priceExclTax = rawPrice;
                    priceInclTax = rawPrice;
                    rowTaxAmount = 0;

                }

                const itemDiscount = parseFloat(item.discount || 0) * itemQty;
                const rowTotalExclTax = (priceExclTax * itemQty) - itemDiscount;
                const rowTotalInclTax = (priceInclTax * itemQty) - itemDiscount;
                if (item.product_type === "bundle") {
                    item.bundleOrderedItems = getBundleOrderedItems(item, sell_price, countryCode);
                }
                let itemRecord = {
                    itemId: item.item_id,
                    mageId: item.mageId,
                    sku: item.item_sku,
                    oracleId: item.oracle_id,
                    appliedRuleIds: (item.applied_rule_ids) ? item.applied_rule_ids : null,
                    //qtyOrdered: item.quantity,
                    qtyOrdered: itemQty,
                    // price: item.price,
                    // priceInclTax: sell_price,
                    price: priceExclTax.toFixed(4),
                    priceInclTax: priceInclTax.toFixed(4),
                    originalPrice: item.original_price,

                    // taxAmount: taxAmount.toFixed(4),

                    // taxPerc: TAX_PERCENT,
                    taxAmount: rowTaxAmount.toFixed(4),
                    taxPerc: countryCode === 'SA' ? taxRate : 0,
                    //rowTotal: rowTotal.toFixed(4),
                    //rowTotalInclTax: rowTotalInclTax.toFixed(4),
                    rowTotal: rowTotalExclTax.toFixed(4),
                    rowTotalInclTax: rowTotalInclTax.toFixed(4),
                    sequenceNo: itemInc + 1,



                    //taxAmount: taxAmount,
                    //taxPerc: item.tax_perc,
                    discount: item.is_gift_product === 1 ? sell_price : item.discount,
                    discountTaxAmt: item.discount_tax_amt,
                    discountPerc: item.discount_perc,
                    //rowTotal: item.is_gift_product === 1 ? item.row_total : rowTotal,
                    //rowTotalInclTax: item.is_gift_product === 1 ? item.row_total_incl_tax : rowTotalInclTax,
                    custom_price: item.isCustom_price,
                    referenceId: item.referenceId,
                    productType: item.product_type,
                    bundleOrderedItems: item.bundleOrderedItems,
                    giftProducts: item.giftProducts,
                    is_gift_product: item.is_gift_product && !isNull(item.is_gift_product) ? item.is_gift_product : 0,
                    gift_parent_id: item.gift_parent_id && !isNull(item.gift_parent_id) ? item.gift_parent_id : null,
                    gift_product_sku: item.gift_product_sku && !isNull(item.gift_product_sku) ? item.gift_product_sku : null
                }
                orderItems.push(itemRecord);
                itemInc++;

            });
            // console.log("orderItems 1164", orderItems);
            setOrderItemsData(orderItems);

        }
    }



    const getApplicableBundleQuantity = (pType, filterBundleItems, qty) => {
        let quantity = qty;
        if (pType === "bundle") {
            if (size(filterBundleItems) > 0) {
                let bundleItemsStockAfterCal = [];
                filterBundleItems.forEach((eachItem) => {
                    let stockVar = {};
                    stockVar.finalStock = eachItem.totalQuantity <= 0 ? 0 : floor(parseFloat(eachItem.totalQuantity) / parseInt(eachItem.bundleSingleItemQty));
                    bundleItemsStockAfterCal.push(stockVar);
                });
                const itemWithMinStock = minBy(bundleItemsStockAfterCal, (bisac) => {
                    return bisac.finalStock;
                });
                quantity = itemWithMinStock.finalStock;
            }
        }
        return quantity;
    }

    const getBundleOrderedItems = (parentItem, bundlePrice, countryCode) =>
        calculateBundleItems(parentItem, bundlePrice, countryCode);

    const handelOrderRemarks = (remarks) => {
        setOrderRemarks({
            isReorder: true,
            parentOrderId: id,
            remarks: remarks
        });
    }

    const handleUserSearch = () => {
        //let searchQuery = userSearchString;
        const searchValue = String(userSearchString || '').trim();
        const params = new URLSearchParams();

        if (searchValue) {
            params.append(
                'search',
                searchValue.replace(/,+$/, '') // remove trailing comma
            );
        }

        if (userChannels?.length > 0) {
            params.append('filter', userChannels.join(','));
        }
        axios.get(`${legolasApi.url}/admin/users?${params.toString()}`).then((res) => {
            if (res.data.success && res.data.count != 0) {
                let users = res.data.users;
                if (orderHeaderData.admin_order_source === "B2B") {
                    users = users.filter((u) => u.group_id === 2);
                    const hasAnySyncedUser = users.some(
                        (u) => u.vinculum_cust_id !== null && u.vinculum_cust_id !== ""
                    );
                    if (!hasAnySyncedUser) {
                        handleAlertGen(
                            "User cannot create order because account is not synced to Vinculum."
                        );
                        return;
                    }

                    users = users.filter((u) => {
                        if (u.vinculum_cust_id) {
                            return true;
                        } else {
                            return false;
                        }
                    });
                } else if (orderHeaderData.admin_order_source !== "B2B") {
                    users = users.filter((u) => u.group_id !== 2);
                }

                if (users.length === 0) {
                    handleAlertGen("No B2B user found with given B2B Source!");
                }
                setSearchedUser(users);
            } else {
                let message = 'No user found with given  B2B Source!'
                handleAlertGen(message)
            }

        }).catch((error) => console.log('Error in getting Product: ', error.message))
    }


    const submitOrder = async () => {
        if (state?.data && !orderHeaderData.channel_id) {
            handleAlertGen('Please wait for the original order to load before placing the reorder.');
            return;
        }
        setLoading(true);
        const finalAdminOrderSource =
            summaryData?.admin_order_source?.trim()
            || watch("admin_order_source")?.trim()
            || orderHeaderData?.admin_order_source?.trim()
            || 'Shababuna';
        const salesPersonName = watch("sales_person_name");
        const isStorePickupMode = deliveryType === "storepickup";
        const effectivePickupStore = isStorePickupMode
            ? normalizePickupStore(
                selectedStores
                || orderHeaderData.store_details
                || data?.summary?.store_details
                || data?.store_details
            )
            : null;
        const selectedDeliveryMethod = orderHeaderData.delivery_method
            || getDeliveryMethodState(deliveryType, nextDayDelivery);
        const selectedDeliveryFee = summaryData?.one_day_delivery_charge || Number(getDeliveryFeeValue(deliveryType, nextDayDelivery)).toFixed(2);
       // let selectedStoreAllocations = nddSelectedStores;
        let errorMessage = '';
        if (orderItemsData.length <= 0) {
            errorMessage = 'Please add items to Order!'
            handleAlertGen(errorMessage);
            setLoading(false);
            return;
        }
        if (customerData.id == null && reorderId == '') {
            errorMessage = 'Please select and add user to Order!'
            handleAlertGen(errorMessage);
            setLoading(false);

            return;
        }

        if (finalAdminOrderSource === "B2B") {
            const firstName = String(addressData.customer_firstname || "").trim();
            const lastName = String(addressData.customer_lastname || "").trim();

            if (firstName.length < 3) {
                handleAlertGen("First Name is required and must contain at least 3 characters for B2B orders.");
                setLoading(false);
                return;
            }

            if (lastName.length < 3) {
                handleAlertGen("Last Name is required and must contain at least 3 characters for B2B orders.");
                setLoading(false);
                return;
            }
        }


        if (!isStorePickupMode && (!salesPersonName || !salesPersonName.trim())) {
            errorMessage = 'Please enter sales person name!'
            handleAlertGen(errorMessage);
            setFocus("sales_person_name"); // from react-hook-form
            setLoading(false);
            return;
        }

        if (reorderId == '') {
            if (orderHeaderData.notes) {
                if (orderHeaderData.notes.length < 5) {
                    errorMessage = 'Please enter notes data between 5 to 255 characters length!';
                    handleAlertGen(errorMessage);
                    setLoading(false);
                    return;
                }
            }
            else {
                errorMessage = 'Please Enter notes';
                handleAlertGen(errorMessage);
                setLoading(false);
                return;
            }

        }
        const orderAddressData = {
            ...addressData,
            customerFirstname: addressData.customer_firstname,
            customerLastname: addressData.customer_lastname,
            street: addressData.street,
            countryCode: addressData.country_code,
            cityId: addressData.city_id,
            districtId: addressData.district_id == 0 ? "0" : addressData.district_id,
            postcode: addressData.postcode ? parseInt(addressData.postcode) : 0,
            phoneExt: addressData.phone_ext,
            phone: addressData.phone,
            flagBilling: addressData.flagBilling ?? 1, //Preserve or default to 1
            premisesCode: addressData.premisesCode,
            customer_unique_id: addressData.customer_unique_id,


        };


        if (orderAddressData.countryCode == "SA" && (!orderAddressData.phoneExt || orderAddressData.phoneExt === '')) {
            orderAddressData.phoneExt = "+966";
        }
        // check user address
        let valid = true;
        let message = '';
        if (isStorePickupMode) {
            if (
                finalAdminOrderSource !== "B2B" &&
                !orderAddressData.customerFirstname?.trim()
            ) {
                valid = false;
                message = "First Name is required!";
            } else if (orderAddressData.phoneExt == '' || orderAddressData.phoneExt == null) {
                valid = false;
                message = 'Country phone ext. is required!'
            } else if (orderAddressData.phone == '' || orderAddressData.phone == null) {
                valid = false;
                message = 'Phone number is required!'
            } else if (
                selectedDeliveryMethod === "store_pickup" &&
                !effectivePickupStore?._id &&
                !effectivePickupStore?.storeCode
            ) {
                valid = false;
                message = "Please select a store for pickup!";
            }
        } else {
            if (
                finalAdminOrderSource !== "B2B" &&
                !orderAddressData.customerFirstname?.trim()
            ) {
                valid = false;
                message = "First Name is required!";
            }
            else if (orderAddressData.street == '' || orderAddressData.street == null) {
                valid = false;
                message = 'Street is required!'
            } else if (orderAddressData.countryCode == '' || orderAddressData.countryCode == null) {
                valid = false;
                message = 'Country is required!'
            } else if (orderAddressData.cityId == '' || orderAddressData.cityId == null) {
                valid = false;
                message = 'City is required!'
            } else if (orderAddressData.cityId == '0' && (orderAddressData.city_id_text == null || orderAddressData.city_id_text == '')) {
                valid = false;
                message = 'City Name is required!'
            }
            else if (orderAddressData.districtId === '0' && (orderAddressData.district_id_text == '' || orderAddressData.district_id_text == null)) {
                valid = false;
                message = 'District Name is required!'
            }
            else if (orderAddressData.districtId == '' || orderAddressData.districtId == null) {
                valid = false;
                message = 'District is required!'
            } else if (orderAddressData.phoneExt == '' || orderAddressData.phoneExt == null) {
                valid = false;
                message = 'Country phone ext. is required!'
            } else if (orderAddressData.phone == '' || orderAddressData.phone == null) {
                valid = false;
                message = 'Phone number is required!'
            }
            else if (!orderAddressData.postcode) {
                valid = false;
                message = 'Postcode is required!';
            }
            else if (orderAddressData.countryCode === 'SA') {
                if (!/^\d{5}$/.test(orderAddressData.postcode.toString())) {
                    valid = false;
                    message = 'For Saudi Arabia, postcode must be exactly 5 digits!';
                }
            } else if (orderAddressData.countryCode === 'QA' && (!orderAddressData.customer_unique_id || !/^\d{11}$/.test(orderAddressData.customer_unique_id)) ||
                (orderAddressData.countryCode === "OM" && (!orderAddressData.customer_unique_id || !/^\d{8}$/.test(orderAddressData.customer_unique_id)))

            ) {
                valid = false;
                message = orderAddressData.countryCode === "QA" ? "Qatari ID must be exactly 11 digits!" : "Oman ID must be exactly 8 digits!";
            }
            if (orderAddressData.countryCode === 'SA' && (!orderAddressData.premisesCode || orderAddressData.premisesCode.trim().length !== 8)) {
                valid = false;
                message = 'National Address Short Code must be exactly 8 characters';
            }
        }

        if (valid && state && (remarksString.length <= 5 || remarksString.length >= 255)) {
            valid = false;
            message = 'Please enter Remarks data between 5 to 255 characters length!'
        } else if (Payment.id == null) {
            valid = false;
            message = 'Please select payment method!'
        }

        const selectedExt = countryExtCodes.find(ele => ele.code == orderAddressData.countryCode);
        if (selectedExt) {
            if (
                ((orderAddressData.phone).toString()).length !== selectedExt.length ||
                !new RegExp(selectedExt.regEx).test(orderAddressData.phone)
            ) {
                valid = false;
                message = 'Please enter a valid phone number';
            }
        } else {
            valid = false;
            message = 'Selected country not supported';
        }


        if ((Payment.id == 1 || Payment.id == 5) && orderAddressCountryCode != 'SA') {
            valid = false;
            message = 'Payment method is not supported for this Order Address!';
        }

        if (!valid) {
            handleAlertGen(message);
            setLoading(false);
            return;
        }

        // if (isStorePickupMode) {
        //     try {
        //         const stockResult = await validateStoreStock(
        //             selectedStores || orderHeaderData.store_details,
        //             orderItemsData
        //         );
        //         if (!stockResult.success) {
        //             showStockDialog(
        //                 stockResult,
        //                 "storepickup",
        //                 selectedStores?.name || orderHeaderData.store_name || "Selected store"
        //             );
        //             setLoading(false);
        //             return;
        //         }

        //         selectedStoreAllocations = stockResult.selectedStore || [];
        //     } catch (error) {
        //         handleAlertGen(error.response?.data?.message || 'Unable to verify store stock. Please try again.');
        //         setLoading(false);
        //         return;
        //     }
        // }
        // if (selectedDeliveryMethod === "next_day_delivery") {
        //     try {
        //         const stockResult = await validateNextDayStock(
        //             addressData.city,
        //             orderItemsData
        //         );

        //         if (!stockResult.success) {
        //             showStockDialog(stockResult, "ndd", addressData.city);

        //             setLoading(false);
        //             return;
        //         }

        //         selectedStoreAllocations = stockResult.selectedStore || [];
        //         setNddSelectedStores(selectedStoreAllocations);

        //     } catch (error) {
        //         handleAlertGen(
        //             error.response?.data?.message ||
        //             "Unable to verify next day delivery stock."
        //         );
        //         setLoading(false);
        //         return;
        //     }
        // }

       let selectedStoreAllocations = [];

if (isStorePickupMode) {
    const stockResult = await validateStoreStock(
        effectivePickupStore,
        orderItemsData
    );

    if (!stockResult.success) {
        const stockMessage = reorderId !== ''
            ? "The existing pickup store does not have enough stock for this reorder. Please select Change store and choose another store."
            : stockResult.message;
        showStockDialog(
            { ...stockResult, message: stockMessage },
            "storepickup",
            selectedStores?.name ||
            orderHeaderData.store_name ||
            "Selected store"
        );

        setLoading(false);
        return;
    }

    selectedStoreAllocations = normalizeStoreAllocations(
        stockResult.selectedStore
    );

    if (!selectedStoreAllocations.length) {
        handleAlertGen(
            "Stock is available, but no valid store allocation was returned."
        );
        setLoading(false);
        return;
    }
}

if (selectedDeliveryMethod === "next_day_delivery") {
    const stockResult = await validateNextDayStock(
        addressData.city,
        orderItemsData
    );

    if (!stockResult.success) {
        const stockMessage = reorderId !== ''
            ? `The existing delivery city (${addressData.city}) does not have enough NDD stock for this reorder. Please change the delivery city or select another delivery method.`
            : stockResult.message;
        showStockDialog(
            { ...stockResult, message: stockMessage },
            "ndd",
            addressData.city
        );

        setLoading(false);
        return;
    }

    selectedStoreAllocations = normalizeStoreAllocations(
        stockResult.selectedStore
    );

    if (!selectedStoreAllocations.length) {
        handleAlertGen(
            "Stock is available, but no valid NDD store allocation was returned."
        );
        setLoading(false);
        return;
    }

    setNddSelectedStores(selectedStoreAllocations);
}

const shouldSendStoreAllocations = [
    "next_day_delivery",
    "store_pickup"
].includes(selectedDeliveryMethod);

const finalStoreAllocations = shouldSendStoreAllocations
    ? normalizeStoreAllocations(selectedStoreAllocations)
    : [];

const selectedPickupStore = isStorePickupMode
    ? effectivePickupStore
    : null;

        let orderPayload = {
            //orderHeader:orderHeaderData,
            orderHeader: {
                ...orderHeaderData,
                admin_order_source: finalAdminOrderSource,

                po_number: watch("po_number"),
                vat_number: watch("vat_number"),
                id_label: watch("id_label"),
                addShippingCharges: parseFloat(addShippingCharges || 0).toFixed(2),
                channel_id: websiteId,
                customerId: customerData.id || orderHeaderData.customerId,
                sales_person_name: salesPersonName?.trim() || "",
                is_store_pickup: isStorePickupMode ? 1 : 0,
                one_day_delivery_charge: selectedDeliveryMethod === "next_day_delivery" ? selectedDeliveryFee : "0.00",
                delivery_method: selectedDeliveryMethod,
                selectedStore: ["next_day_delivery", "store_pickup"].includes(selectedDeliveryMethod)
                    ? selectedStoreAllocations
                    : [],
                store_wise_stock: ["next_day_delivery", "store_pickup"].includes(selectedDeliveryMethod)
                    ? selectedStoreAllocations
                    : [],
                store_details: selectedPickupStore,

                store_id: isStorePickupMode
                    ? (selectedPickupStore?._id || orderHeaderData.store_id || "")
                    : "",

                store_name: isStorePickupMode
                    ? (selectedPickupStore?.name || orderHeaderData.store_name || "")
                    : "",
                delivery_method_price: selectedDeliveryMethod === "next_day_delivery" ? selectedDeliveryFee : "0.00",
                //store_details: selectedDeliveryMethod === "store_pickup" ? selectedStores : null,

            },
            orderAddress: orderAddressData,
            orderItems: [...orderItemsData, ...productsInBundle],
            paymentData: orderPaymentData,
            remarksData: {
                parentOrderId: (state) ? state.data : null,
                remarks: remarksString
            }
        };
      
console.log("Final create-order payload:", orderPayload);

    try {
    const response = await axios.post(
        `${legolasApi.url}/orders/createorder`,
        orderPayload,
        {
            headers: {
                Authorization: "Bearer null",
                "Content-Type": "application/json"
            }
        }
    );

    const data = response.data || {};

    if (!data.success) {
        throw new Error(
            data.message || "Order creation failed."
        );
    }

    handleAlertSuccess(
        data.message || "Order created successfully!"
    );

    redirectHnadler(data.orderId);
} catch (error) {
    const responseData = error.response?.data;

    console.error("Create order failed:", {
        status: error.response?.status,
        response: responseData,
        message: error.message,
        payload: orderPayload
    });

    if (responseData && Array.isArray(responseData.errors) && responseData.errors.length) {
        const stockMode = selectedDeliveryMethod === "next_day_delivery"
            ? "ndd"
            : "storepickup";
        const stockLocation = selectedDeliveryMethod === "next_day_delivery"
            ? addressData.city
            : selectedStores?.name || orderHeaderData.store_name || "Selected store";

        showStockDialog(responseData, stockMode, stockLocation);
        return;
    }

    handleAlertGen(
        responseData?.message ||
        responseData?.error ||
        error.message ||
        "Order creation failed."
    );
} finally {
    setLoading(false);
}
    }
    const filteredCityList = React.useMemo(() => {
        if (!citySearch) return cityList;

        return cityList.filter((city) =>
            (city.value || "")
                .toLowerCase()
                .includes(citySearch.toLowerCase())
        );
    }, [citySearch, cityList]);

    const filteredDistrictList = React.useMemo(() => {
        if (!districtList.length) return [];

        let list = [];

        if (addressData.city_id && addressData.city_id !== '0') {
            const selectedCity = cityList.find(
                city => city.id == addressData.city_id
            );

            if (selectedCity) {
                list = districtList.filter(
                    d => d.city_id === selectedCity.value
                );
            }
        }

        if (addressData.district_id && addressData.district_id !== '0') {
            const selectedDistrict = districtList.find(
                d => d.id == addressData.district_id
            );

            if (
                selectedDistrict &&
                !list.some(d => d.id == selectedDistrict.id)
            ) {
                list = [selectedDistrict, ...list];
            }
        }

        if (!districtSearch) return list;

        return list.filter(d =>
            (d.value || '')
                .toLowerCase()
                .includes(districtSearch.toLowerCase())
        );
    }, [
        addressData.city_id,
        addressData.district_id,
        districtSearch,
        cityList,
        districtList
    ]);

    // City and district lists can contain hundreds of records. Building all
    // MenuItem elements again for every address keystroke made the controlled
    // form noticeably laggy. Recreate them only when the filtered list changes.
    const cityMenuItems = React.useMemo(() => (
        filteredCityList.map(city => (
            <MenuItem key={city.id} value={city.id}>{city.value}</MenuItem>
        ))
    ), [filteredCityList]);

    const districtMenuItems = React.useMemo(() => (
        filteredDistrictList.map(district => (
            <MenuItem key={district.id} value={district.id}>
                {district.value}
            </MenuItem>
        ))
    ), [filteredDistrictList]);


    const redirectHnadler = (orderId = null) => {
        if (orderId) {
            // const orderId = data.summary['order_id']
            const redirectUrl = `/orders/${orderId}`
            navigate(redirectUrl)
        } else {
            const redirectUrl = `/orders`
            navigate(redirectUrl)
        }

    }

    const closePackage = () => {
        // setOpenPackage(false)
    }

    const handleAlertSuccess = (message) => {
        setAlertSuccess(message)
        setOpenSuccess(true)
        setTimeout(() => {
            setAlertSuccess('')
            setOpenSuccess(false)
        }, 5000)
    }

    const handleAlertGen = (message) => {
        setAlertText(message)
        setOpenAlert(true)
        setTimeout(() => {
            setAlertText('')
            setOpenAlert(false)
        }, 5000)
    }

    const closeSuccess = () => {
        setOpenSuccess(false)
    }

    const closeAlert = () => {
        setOpenAlert(false)
    }

    const handleSearch = (e) => {
        switch (e.target.name) {
            case "coupon_code":
                setCouponCode(e.target.value);
                break;
            case "userSearch":
                setUserSearchString(e.target.value);
                break;
            default:
                break;
        }
    }

    const orderItems = (item) => {
        const sell_price = getItemPriceForCountry(item);
        // Keep the saved order quantity visible even when current stock is lower or zero.
        const selectedQuantity = Number(item.quantity);
        const quantityOptions = [...new Set([...(item.qtyList || []), selectedQuantity]
            .map(Number)
            .filter(quantity => Number.isInteger(quantity) && quantity > 0))]
            .sort((a, b) => a - b);
        let subTotalCart = parseFloat(sell_price * parseInt(item.quantity));
        let itemDiscountCart = parseFloat(item.discount) * parseInt(item.quantity);
        let rowSubTotalCart = subTotalCart - itemDiscountCart;
        return (
            <>
                {(item.referenceId === null || item.product_type === "bundle") &&
                    <StyledTableRow key={item.id} >
                        <StyledTableCell component="th" scope="row">
                            <Typography>{item.name}</Typography>
                            <Typography>{item.item_sku} </Typography>
                            <Typography>{item.oracle_id} </Typography>
                        </StyledTableCell>
                        <StyledTableCell align="center">{parseFloat(sell_price).toFixed(2)}</StyledTableCell>
                        <StyledTableCell align="center">
                            <select
                                disabled={item.is_gift_product === 1 ? true : false}
                                style={{ width: '3rem' }}
                                value={Number.isInteger(selectedQuantity) && selectedQuantity > 0 ? selectedQuantity : ''}
                                name="qty" onChange={(e) => handleItemCartQty(item, e.target.value)}>
                                {
                                    quantityOptions.map((value) => {
                                        return (
                                            <option key={value} value={value}>{value}</option>
                                        )
                                    })
                                }
                            </select>
                        </StyledTableCell>
                        <StyledTableCell align="center">{subTotalCart.toFixed(2)}</StyledTableCell>
                        <StyledTableCell align="center">{itemDiscountCart.toFixed(2)}</StyledTableCell>
                        <StyledTableCell align="center">{rowSubTotalCart.toFixed(2)}</StyledTableCell>
                        <StyledTableCell align="center"><Button onClick={() => deleteProductFromCart(item)}>DELETE</Button></StyledTableCell>
                    </StyledTableRow>
                }
            </>
        );
    }

    return (
        <Box sx={{ width: '100%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeAlert} severity="warning" sx={{ width: '400px', marginTop: '100px' }}>
                    {alertText}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={closeSuccess} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
                    {alertSuccess}
                </Alert>
            </Snackbar>
            <Dialog
                open={stockDialog.open}
                onClose={() => setStockDialog(prev => ({ ...prev, open: false }))}
                maxWidth="sm"
                fullWidth
                PaperProps={{ sx: { borderRadius: 2, maxHeight: '82vh' } }}
            >
                <DialogTitle sx={{ p: 0 }}>
                    <Box sx={{
                        px: 2,
                        py: 1.25,
                        color: '#fff',
                        backgroundColor: stockDialog.success ? '#16794b' : '#b42318',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Box>
                            <Typography sx={{ fontWeight: 700, fontSize: '1rem', lineHeight: 1.3 }}>
                                {stockDialog.mode === "ndd" ? "Next Day Delivery Stock" : "Store Pickup Stock"}
                            </Typography>
                            <Typography variant="caption" sx={{ opacity: 0.9 }}>
                                {stockDialog.location || "Selected location"}
                            </Typography>
                        </Box>
                        <IconButton
                            onClick={() => setStockDialog(prev => ({ ...prev, open: false }))}
                            size="small"
                            sx={{ color: '#fff', p: 0.5 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: 2, overflowY: 'auto' }}>
                    <Alert
                        severity={stockDialog.success ? "success" : "warning"}
                        sx={{ mb: 1.5, py: 0, '& .MuiAlert-message': { py: 0.75, fontSize: '0.82rem' } }}
                    >
                        {stockDialog.success
                            ? "All order items are available for this delivery option."
                            : stockDialog.message}
                    </Alert>

                    <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
                        Product availability
                    </Typography>
                    {stockDialog.products.length === 0 ? (
                        <Typography color="text.secondary">No product stock information returned.</Typography>
                    ) : stockDialog.products.map((product, index) => {
                        const isAvailable = product.available >= product.requested;
                        return (
                            <Paper key={`${product.productId}-${index}`} variant="outlined" sx={{ p: 1.25, mb: 1, borderRadius: 1.5 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'flex-start' }}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 700, fontSize: '0.875rem', lineHeight: 1.3 }}>{product.name}</Typography>
                                        {product.oracleId && (
                                            <Typography variant="caption" color="text.secondary">
                                                Oracle ID: {product.oracleId}
                                            </Typography>
                                        )}
                                    </Box>
                                    <Chip
                                        size="small"
                                        color={isAvailable ? "success" : "error"}
                                        label={isAvailable ? "Available" : "Insufficient stock"}
                                        sx={{ height: 22, fontSize: '0.7rem' }}
                                    />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2, mt: 0.75 }}>
                                    <Typography variant="caption"><strong>Requested:</strong> {product.requested}</Typography>
                                    <Typography variant="caption"><strong>Available:</strong> {product.available}</Typography>
                                </Box>
                                {product.alternatives.length > 0 && (
                                    <Box sx={{ mt: 1 }}>
                                        <Divider sx={{ mb: 0.75 }} />
                                        <Typography variant="caption" sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>
                                            Available at other stores
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {product.alternatives.map(store => (
                                                <Chip
                                                    key={store.storeCode}
                                                    variant="outlined"
                                                    color={store.available >= product.requested ? "success" : "default"}
                                                    label={`${store.storeName} · Qty ${store.available}`}
                                                    size="small"
                                                    sx={{ height: 23, fontSize: '0.7rem' }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                            </Paper>
                        );
                    })}

                    {stockDialog.mode === "ndd" && stockDialog.success && stockDialog.allocations.length > 0 && (
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
                                Fulfilment allocation
                            </Typography>
                            <TableContainer component={Paper} variant="outlined">
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Product</TableCell>
                                            <TableCell>Store code</TableCell>
                                            <TableCell align="right">Allocated qty</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {stockDialog.allocations.map((allocation, index) => (
                                            <TableRow key={`${allocation.oracleId}-${allocation.storeCode}-${index}`}>
                                                <TableCell sx={{ py: 0.75 }}>
                                                    <Typography variant="body2">{getLocalizedProductName(allocation.productName)}</Typography>
                                                    {allocation.oracleId && (
                                                        <Typography variant="caption" color="text.secondary">
                                                            Oracle ID: {allocation.oracleId}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.75 }}>{allocation.storeCode}</TableCell>
                                                <TableCell sx={{ py: 0.75 }} align="right">{allocation.selectedqty}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ px: 2, py: 1.25 }}>
                    {!stockDialog.success && stockDialog.mode === "storepickup" && (
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                                setStockDialog(prev => ({ ...prev, open: false }));
                                setShowStoresSelector(true);
                            }}
                        >
                            Change store
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => setStockDialog(prev => ({ ...prev, open: false }))}
                        sx={{ backgroundColor: '#2b3f7a' }}
                    >
                        {stockDialog.success ? "Continue" : "Close"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{
                display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
                '& .MuiTypography-root': {
                    fontSize: '2.5rem',
                    fontWeight: 400,
                    color: '#000'
                }
            }}>
                {(reorderId != '') && <Typography>Create Re-Order for {reorderId} </Typography>}
                {(reorderId == '') && <Typography>Create New Order </Typography>}
            </Box>

            <BottomNavigation
                showLabels
                sx={globalStyles.bottomNavigationMenu}>
                <BottomNavigationAction onClick={() => redirectHnadler(reorderId)} label="Cancel" />
                <BottomNavigationAction disabled={loading} onClick={() => submitOrder()} label={loading ? "Submiting...." : "Submit Order"} />

            </BottomNavigation>

            <Box sx={{ width: '85%', marginLeft: '7%' }}>
                {(reorderId == '') ?
                    <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
                        <Box sx={{ width: '100%', paddingBottom: '10px' }}>
                            <Typography variant='h6'>Order Source</Typography>
                        </Box>
                        <Grid container spacing={5} columns={24}>
                            <Grid item xs={11}>
                                <Box sx={{ width: '50%' }}>
                                    <Controller
                                        name="admin_order_source"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                placeholder='country'
                                                value={summaryData.admin_order_source}
                                                defaultValue={orderHeaderData.admin_order_source}
                                                label="Country"
                                                sx={{ width: '70%', overflow: 'visible' }}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    handleSource(e.target.value);
                                                }}
                                            >
                                                <MenuItem value={'Shababuna'}>Shababuna</MenuItem>
                                                <MenuItem value={'B2B'}>B2B</MenuItem>

                                            </Select>
                                        )}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    : <Box sx={{ fontSize: '20px', color: 'green', fontWeight: 600, margin: '20px' }}>
                        Order Source : {summaryData.admin_order_source}
                    </Box>
                }

                {/* <Grid container spacing={2} columns={24} sx={{ mt: 2 }}>
                    <Grid item xs={11}>
                        <Box sx={{ backgroundColor: '#f8f9fc', border: '1px solid #e0e0e0', borderRadius: '8px', p: 2, width: '50%' }}>
                            <Controller
                                name="sales_person_name"
                                control={control}
                                rules={{ required: "Sales Person Name is required" }}
                                render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        label="Sales Person Name*"
                                        //value={orderHeaderData.sales_person_name || ''}
                                        // defaultValue={orderHeaderData.sales_person_name || ''}

                                        // onChange={(e) => setOrderHeaderData(prev => ({ ...prev,
                                        //         sales_person_name: e.target.value
                                        //     }))
                                        // }
                                        placeholder="Enter Name"
                                        fullWidth
                                        error={!!error}
                                        helperText={error?.message}
                                        onFocus={handleOutsideFocus}
                                    />
                                )}
                            />
                        </Box>
                    </Grid>
                </Grid> */}



                <Box id='items-container' sx={{ paddingTop: '50px' }}>
                    <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                        <Typography variant='h6'>Order Items</Typography>
                    </Box>
                    <Box>
                        <Input
                            type='search'
                            onFocus={handleOutsideFocus}
                            sx={{ border: '1px solid #2b3f7a', borderRadius: '20px', marginRight: '40px', padding: '0px 10px 0px' }}
                            endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleProductSearch('sku')} />}
                            placeholder='Seach by EcomId / SKU'
                            name="skuSearch"
                            inputRef={skuSearchInputRef}
                        />
                        <Input
                            type='search'
                            onFocus={handleOutsideFocus}
                            sx={{ border: '1px solid #2b3f7a', borderRadius: '20px', marginRight: '40px', padding: '0px 10px 0px' }}
                            endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleProductSearch('oracle_id')} />}
                            placeholder='Seach by Oracle ID'
                            name="oracleIdSearch"
                            inputRef={oracleIdSearchInputRef}
                        />
                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <Typography variant='h6'>Searched Item</Typography>
                        </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">Id </StyledTableCell>
                                        <StyledTableCell align="center">Oracle Id</StyledTableCell>
                                        <StyledTableCell align="center">Name</StyledTableCell>
                                        <StyledTableCell align="center">Price</StyledTableCell>
                                        {/* {customizePriceVisible && searchedItems.some(i => i.product_type !== 'bundle') && (<StyledTableCell align="center">B2B Customise Price</StyledTableCell>)}<StyledTableCell align="center">Quantity</StyledTableCell> */}
                                        {customizePriceVisible && searchedItems.some(i => i.product_type !== 'bundle') && (<StyledTableCell align="center"> Customise Price</StyledTableCell>)}<StyledTableCell align="center">Quantity</StyledTableCell>
                                        <StyledTableCell align="center">ACTION</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {searchedItems.map((item) => {
                                        return (
                                            <StyledTableRow key={item.item_id}>

                                                <StyledTableCell align="center">
                                                    <Typography align="center">{item.item_sku}</Typography>
                                                </StyledTableCell>

                                                <StyledTableCell align="center">
                                                    <Typography align="center">{item.oracle_id}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Typography align="center">{item.name}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Typography align="center">{getItemPriceForCountry(item).toFixed(2)}</Typography>
                                                </StyledTableCell>
                                                {customizePriceVisible && item.product_type !== 'bundle' && (
                                                    <StyledTableCell align="center">

                                                        <Typography align="center">

                                                            <Input type='text'
                                                                autoFocus={focus}
                                                                onFocus={handleFocus}
                                                                disabled={buttonClicked}
                                                                name='customizePrice'
                                                                value={customizePrice ?? ''}
                                                                error={isCustomizePriceInvalid}
                                                                style={{ width: '100px', border: '2px solid black' }}
                                                                onChange={handleCustomizePrice}
                                                            />
                                                        </Typography>
                                                    </StyledTableCell>
                                                )}
                                                <StyledTableCell align="center">
                                                    <Typography align="center">{item.quantity - item.on_hold_stock}</Typography>
                                                </StyledTableCell>
                                                <StyledTableCell align="center" ><Button disabled={customizePriceVisible && item.product_type !== 'bundle' && isCustomizePriceInvalid} onClick={() => addProductToCart(item)}>ADD</Button></StyledTableCell>

                                            </StyledTableRow>

                                        )

                                    })}

                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <Typography variant='h6'>Items in Order</Typography>
                        </Box>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">

                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">Product</StyledTableCell>
                                        <StyledTableCell align="center">Price</StyledTableCell>
                                        <StyledTableCell align="center">Quantity</StyledTableCell>
                                        <StyledTableCell align="center">Subtotal</StyledTableCell>
                                        <StyledTableCell align="center">Discount</StyledTableCell>
                                        <StyledTableCell align="center">Row Subtotal</StyledTableCell>
                                        <StyledTableCell align="center">Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        orderCartItems && orderCartItems.map((item) => {
                                            return (
                                                orderItems(item)
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}>

                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                {orderCoupon && orderCoupon != null && orderCoupon != '' &&
                                    <Grid item xs={6}>
                                        <Typography><b>Applied Coupon Code is: </b>{orderCoupon}</Typography>

                                        <Button
                                            sx={{
                                                backgroundColor: '#2b3f7a !important',
                                                borderRadius: 0,
                                                padding: '5px 10px',
                                                color: '#fff',
                                                textTransform: 'capitalize'
                                            }}
                                            onClick={() => handleApplyCoupon('remove')}
                                        >
                                            <Typography>Remove</Typography>
                                        </Button>
                                    </Grid>
                                }
                                {(orderCoupon == null || orderCoupon == '') &&
                                    <Grid item xs={6}>
                                        <Typography>* Apply Coupon Code after all Item changes and address changes</Typography>
                                        <Input
                                            type='text'
                                            onFocus={handleOutsideFocus}
                                            name='coupon_code'
                                            value={couponCode || ''}
                                            sx={{ border: '1px solid #2b3f7a', width: '30%', height: '40px', marginRight: '30px' }}
                                            onChange={(event) => setCouponCode(event.target.value)}
                                        />
                                        <Button
                                            sx={{
                                                backgroundColor: '#2b3f7a !important',
                                                borderRadius: 0,
                                                padding: '5px 10px',
                                                color: '#fff',
                                                textTransform: 'capitalize'
                                            }}
                                            onClick={() => handleApplyCoupon('add')}
                                        >
                                            <Typography>Apply Coupon</Typography>
                                        </Button>
                                    </Grid>
                                }

                            </Grid>
                            {/* <Button
                                sx={{
                                    backgroundColor: '#2b3f7a !important',
                                    borderRadius: 0,
                                    padding: '5px 10px',
                                    color: '#fff',
                                    textTransform: 'capitalize',
                                    width: '200px'
                                }}
                            >
                                <Typography>Update Items & Qty</Typography>
                            </Button> */}
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '40px 0 20px 0', paddingBottom: '10px', }}>
                    <Typography variant='h6'>Account Information</Typography>
                </Box>
                {(reorderId == '') &&
                    <Box>
                        <Grid
                            container
                            alignItems="center"
                            spacing={2}
                            sx={{
                                backgroundColor: '#f8f9fc',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                p: 2
                            }}
                        >
                            {/* Search User */}
                            <Grid item xs={12} md={5}>
                                <Input
                                    type="search"
                                    onFocus={handleOutsideFocus}
                                    sx={{
                                        border: '1px solid #2b3f7a',
                                        borderRadius: '20px',
                                        width: '100%',
                                        px: 2,
                                        backgroundColor: '#fff'
                                    }}
                                    endAdornment={
                                        <SearchIcon
                                            sx={{ cursor: 'pointer' }}
                                            onClick={() => handleUserSearch('email')}
                                        />
                                    }
                                    placeholder="Search user by email"
                                    name="userSearch"
                                    onBlur={handleSearch}
                                />
                            </Grid>

                            {/* OR Divider */}
                            <Grid item xs={12} md={2} sx={{ textAlign: 'center' }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 1
                                    }}
                                >
                                    <Box sx={{ height: '1px', width: '30%', backgroundColor: '#ccc' }} />
                                    <Typography sx={{ fontWeight: 600, color: '#666' }}>
                                        OR
                                    </Typography>
                                    <Box sx={{ height: '1px', width: '30%', backgroundColor: '#ccc' }} />
                                </Box>
                            </Grid>

                            {/* Enter New User */}
                            <Grid item xs={12} md={5} sx={{ textAlign: 'right' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#2b3f7a !important',
                                        borderRadius: '6px',
                                        px: 4,
                                        py: 1.2,
                                        fontWeight: 600,
                                        textTransform: 'capitalize',
                                        boxShadow: '0px 3px 8px rgba(0,0,0,0.15)'
                                    }}
                                    onClick={handleAddNewUser}
                                >
                                    + Add New Customer
                                </Button>
                            </Grid>
                        </Grid>

                        <Box sx={{ width: '100%', marginTop: '20px' }}>
                            <Typography variant='h6'>Searched User</Typography>
                        </Box>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">UserId</StyledTableCell>
                                        <StyledTableCell align="center">First Name</StyledTableCell>
                                        <StyledTableCell align="center">Last Name</StyledTableCell>
                                        <StyledTableCell align="center">Email</StyledTableCell>
                                        <StyledTableCell align="center">Channel</StyledTableCell>
                                        <StyledTableCell align="center">Action</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {searchedUser.map((user) => {

                                        return (
                                            <StyledTableRow >
                                                <StyledTableCell component="th" scope="row" align="center">{user.id}</StyledTableCell>
                                                <StyledTableCell align="center">{user.group_id == 2 ? user.firstnamear : user.firstname}</StyledTableCell>
                                                <StyledTableCell align="center">{user.group_id == 2 ? user.lastnamear : user.lastname}</StyledTableCell>
                                                <StyledTableCell align="center">{user.email}</StyledTableCell>
                                                <StyledTableCell align="center">{user.channel ? user.channel : user.channelId}</StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Button onClick={() => selectThisUser(user)}>SELECT</Button>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        )
                                    })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                }

                <Box sx={{ width: '100%', marginTop: '20px' }}>
                    {(reorderId != '') && <Typography variant='h6'>User Details</Typography>}
                    {(reorderId == '') && <Typography variant='h6'>Selected User Details</Typography>}
                </Box>


                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center">UserId</StyledTableCell>
                                <StyledTableCell align="center">First Name</StyledTableCell>
                                <StyledTableCell align="center">Last Name</StyledTableCell>
                                <StyledTableCell align="center">Email</StyledTableCell>
                                <StyledTableCell align="center">Channel</StyledTableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow >
                                <StyledTableCell component="th" scope="row" align="center">{(customerData.email != null) ? customerData.id : ''}</StyledTableCell>
                                <StyledTableCell align="center">{(customerData.email != null) ? (customerData.group_id == 2 ? customerData.firstnamear : customerData.firstname) : ''}</StyledTableCell>
                                <StyledTableCell align="center">{(customerData.email != null) ? (customerData.group_id == 2 ? customerData.lastnamear : customerData.lastname) : ''}</StyledTableCell>
                                <StyledTableCell align="center">{(customerData.email != null) ? customerData.email : (customerData.guest_user_email != null) ? customerData.guest_user_email + (' -(Guest)') : ''}</StyledTableCell>
                                <StyledTableCell align="center">{(customerData.email != null) ? (customerData.channel ? customerData.channel : summaryData.channel) : ''}</StyledTableCell>

                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
                    <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                        <Typography variant='h6'> Address Information </Typography>
                    </Box>
                    <Grid container spacing={5} columns={24}>
                        <Grid item xs={16}>
                            {!isB2BOrder && <Box sx={{ mt: 2, mb: 3, p: 2, border: '1px solid #dcdcdc', borderRadius: '12px', background: '#fafafa' }}>
                                <Typography variant='h6' sx={{ mb: 2, fontWeight: 600, color: '#2b3f7a' }}>Delivery Type</Typography>
                                <RadioGroup row value={deliveryType} onChange={handleDeliveryTypeChange} sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: 2, width: '100%' }}>
                                    <Box sx={{ flex: 1, border: deliveryType === 'delivery' ? '2px solid #2b3f7a' : '1px solid #dcdcdc', borderRadius: '10px', padding: '12px 18px', background: deliveryType === 'delivery' ? '#f4f7ff' : '#fff', transition: '0.3s ease', cursor: isStorePickupReorder ? 'not-allowed' : 'pointer', opacity: isStorePickupReorder ? 0.55 : 1, display: 'flex', alignItems: 'center' }}>
                                        <FormControlLabel value="delivery" disabled={isStorePickupReorder} control={<Radio />} label={
                                            <Box>
                                                <Typography sx={{ fontWeight: 600 }}>Delivery Address </Typography>
                                                <Typography variant='body2' sx={{ color: '#666' }}> Deliver order to customer address</Typography>
                                            </Box>
                                        }
                                            sx={{ margin: 0, width: '100%' }} />
                                    </Box>
                                    <Box
                                        onClick={() => {
                                            if (!isNextDayDeliveryReorder && deliveryType === 'storepickup') {
                                                setShowStoresSelector(true);
                                            }
                                        }}
                                        sx={{ flex: 1, border: deliveryType === 'storepickup' ? '2px solid #2b3f7a' : '1px solid #dcdcdc', borderRadius: '10px', padding: '12px 18px', background: deliveryType === 'storepickup' ? '#f4f7ff' : '#fff', transition: '0.3s ease', cursor: isNextDayDeliveryReorder ? 'not-allowed' : 'pointer', opacity: isNextDayDeliveryReorder ? 0.55 : 1, display: 'flex', alignItems: 'center' }}
                                    >
                                        <FormControlLabel value="storepickup" disabled={isNextDayDeliveryReorder} control={<Radio />}
                                            label={<Box>
                                                <Typography sx={{ fontWeight: 600 }}>Store Pickup</Typography>
                                                <Typography variant='body2' sx={{ color: '#666' }}>Customer will pickup from store</Typography>
                                            </Box>
                                            }
                                            sx={{ margin: 0, width: '100%' }}
                                        />
                                    </Box>
                                </RadioGroup>
                            </Box>}
                            {isStoresPickup ? (
                                <>
                                    <Box mt={2}>
                                        <Typography variant="h6"> Store Pickup</Typography>
                                        <form style={{ marginLeft: '30%' }}>
                                            <Controller
                                                name='customer_firstname'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => <TextField {...field} label='First Name*' onFocus={handleOutsideFocus} value={addressData.customer_firstname} onChange={(e) => handleChangeform(e)} inputProps={isB2BOrder ? { minLength: 3 } : undefined} fullWidth />}
                                            />
                                            <Controller
                                                name='customer_lastname'
                                                control={control}
                                                // rules={{ required: true }}
                                                render={({ field }) => <TextField {...field} label={isB2BOrder ? 'Last Name*' : 'Last Name'} onFocus={handleOutsideFocus} value={addressData.customer_lastname} onChange={(e) => handleChangeform(e)} inputProps={isB2BOrder ? { minLength: 3 } : undefined} fullWidth />}
                                            />
                                            <Box
                                                sx={{
                                                    display: 'inline-flex',
                                                    width: '100%',
                                                    alignItems: 'center',
                                                    margin: '10px'
                                                }}
                                            >
                                                <Box sx={{ width: '20%' }}>
                                                    {'Country:'}
                                                </Box>

                                                <Box sx={{ width: '50%' }}>
                                                    {/* <Controller
                                                        name="country_code"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Select
                                                                {...field}
                                                                label="Country"
                                                                value={addressData.country_code}
                                                                sx={{
                                                                    width: '100%',
                                                                    overflow: 'visible'
                                                                }}
                                                                onChange={(e) => handleChangeform(e)}
                                                            >
                                                                {countryList.map((country) => (
                                                                    <MenuItem
                                                                        key={country.code}
                                                                        value={country.code}
                                                                    >
                                                                        {country.value}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        )}
                                                    /> */}
                                                    <Controller
                                                        name="country_code"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Select
                                                                {...field}
                                                                value="SA"
                                                                disabled
                                                                sx={{
                                                                    width: '100%',
                                                                    overflow: 'visible'
                                                                }}
                                                            >
                                                                <MenuItem value="SA">
                                                                    Saudi Arabia
                                                                </MenuItem>
                                                            </Select>
                                                        )}
                                                    />
                                                </Box>
                                            </Box>
                                            <Controller
                                                name='phone_ext'
                                                control={control}
                                                //rules={{ required: true}}
                                                render={({ field }) => <TextField {...field} label='Country Phone Ext*' value={countryPhoneExt} disabled onChange={(e) => handleChangeform(e)} fullWidth />}
                                            />
                                            <Controller
                                                name='phone'
                                                control={control}
                                                //rules={{ required: true}}
                                                render={({ field }) => <TextField {...field} label='Phone Number*' value={addressData.phone}
                                                    placeholder={phonePH} onChange={(e) => handleChangeform(e)} fullWidth />}
                                            />
                                            {selectedStores && (
                                                <Paper elevation={2}
                                                    sx={{ p: 3, mt: 2, border: '1px solid #ddd', borderRadius: '10px', background: '#fafafa' }}>
                                                    <Typography variant="h6"
                                                        sx={{ mb: 2, fontWeight: 600, color: '#2b3f7a' }} >Store Details</Typography>
                                                    <Typography sx={{ mb: 1 }}><strong>Store Name:</strong>{" "} {selectedStores?.name || "-"}</Typography>
                                                    <Typography sx={{ mb: 1 }}><strong>Address:</strong>{" "}{selectedStores?.address || "-"}</Typography>
                                                    <Typography sx={{ mb: 1 }}> <strong>City:</strong>{" "}{selectedStores?.city || "-"}</Typography>

                                                    <Typography sx={{ mb: 1 }}><strong>District:</strong>{" "}{selectedStores?.district || "-"}</Typography>
                                                    <Typography sx={{ mb: 1 }}><strong>Country:</strong>{" "}{selectedStores?.country || "-"}</Typography>
                                                    <Typography sx={{ mb: 1 }}>
                                                        <strong>Timing:</strong>{" "}
                                                        {Array.isArray(selectedStores?.timing)
                                                            ? selectedStores.timing.join(', ') || '-'
                                                            : selectedStores?.timing || '-'}
                                                    </Typography>
                                                    <Typography sx={{ mb: 1 }}>
                                                        <strong>Location:</strong>{" "}
                                                        {selectedStores?.urls?.length > 0 ? selectedStores.urls.map((url, index) => (
                                                            <Button
                                                                key={`${url}-${index}`}
                                                                variant="contained"
                                                                size="small"
                                                                sx={{ textTransform: "none", borderRadius: 2, backgroundColor: "#2b3f7a", boxShadow: "none", ml: 1, mb: 0.5, '&:hover': { backgroundColor: "#1f2f5f", boxShadow: "none" } }}
                                                                onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
                                                            >
                                                                📍 View location {selectedStores.urls.length > 1 ? index + 1 : ''}
                                                            </Button>
                                                        )) : '-'}
                                                    </Typography>
                                                    <Typography sx={{ mb: 1 }}><strong>Mobile:</strong>{" "}{selectedStores?.mobile || "-"}</Typography>
                                                    <Typography sx={{ mb: 1 }}><strong>Store Code:</strong>{" "}{selectedStores?.storeCode || "-"}</Typography>
                                                    <Button variant="contained" sx={{ mt: 3, borderRadius: '8px', textTransform: 'none', backgroundColor: '#2b3f7a', '&:hover': { backgroundColor: '#1f2f5f' } }}
                                                        onClick={() => setShowStoresSelector(true)}>
                                                        Change Store
                                                    </Button>
                                                </Paper>
                                            )}
                                        </form>
                                        <Dialog open={showStoresSelector} onClose={() => setShowStoresSelector(false)} maxWidth="sm" fullWidth>
                                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                Select Store
                                                <IconButton onClick={() => setShowStoresSelector(false)}>
                                                    <CloseIcon />
                                                </IconButton>
                                            </DialogTitle>
                                            <DialogContent>
                                                <TextField select fullWidth label="Select Store"
                                                    value={selectedStores?._id || ""}
                                                    onChange={handleStoreChange}
                                                    sx={{ mt: 1 }}
                                                >
                                                    {storesList.map((store) => (
                                                        <MenuItem key={store._id} value={store._id}>{store?.name?.["en-SA"]}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => setShowStoresSelector(false)} color="secondary">
                                                    Cancel
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <form style={{ marginLeft: '30%' }}>
                                        <Controller
                                            name='customer_firstname'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field }) => <TextField {...field} label='First Name*' onFocus={handleOutsideFocus} value={addressData.customer_firstname} onChange={(e) => handleChangeform(e)} inputProps={isB2BOrder ? { minLength: 3 } : undefined} fullWidth />}
                                        />
                                        <Controller
                                            name='customer_lastname'
                                            control={control}
                                            // rules={{ required: true }}
                                            render={({ field }) => <TextField {...field} label={isB2BOrder ? 'Last Name*' : 'Last Name'} onFocus={handleOutsideFocus} value={addressData.customer_lastname} onChange={(e) => handleChangeform(e)} inputProps={isB2BOrder ? { minLength: 3 } : undefined} fullWidth />}
                                        />

                                        <Controller
                                            name='street'
                                            control={control}
                                            rules={{ required: true }}
                                            render={({ field }) => <TextField {...field} label='Street Address*' onFocus={handleOutsideFocus} value={addressData.street} onChange={(e) => handleChangeform(e)} fullWidth />}
                                        />
                                        {orderHeaderData.admin_order_source === 'B2B' && (
                                            <Controller
                                                name='building_no'
                                                control={control}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        label='Building No.*'
                                                        onFocus={handleOutsideFocus}
                                                        value={addressData.building_no || ''}
                                                        onChange={(e) => handleChangeform(e)}
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        )}
                                        <Box sx={{
                                            display: 'inline-flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            margin: '10px'
                                        }}>
                                            <Box sx={{ width: '20%' }}>{'Country:'}</Box>
                                            <Box sx={{ width: '50%' }}>
                                                <Controller
                                                    name="country_code"
                                                    control={control}
                                                    //rules={{ required: true}}
                                                    render={({ field }) =>
                                                        <>
                                                            <Select
                                                                {...field}
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                // defaultValue={countryname}
                                                                placeholder='country'
                                                                label="Country"
                                                                value={addressData.country_code}
                                                                sx={{ width: '100%', overflow: 'visible' }}
                                                                onChange={(e) => handleChangeform(e)}
                                                            >
                                                                {countryList.map((country) => {

                                                                    return (
                                                                        <MenuItem name={country.code} value={country.code}>{country.value}</MenuItem>
                                                                    )
                                                                })}

                                                            </Select>
                                                        </>}
                                                />
                                                {(addressData.country_code === 'QA' || addressData.country_code === 'OM') && (
                                                    <Controller
                                                        name="customer_unique_id"
                                                        control={control}
                                                        rules={{
                                                            required: addressData.country_code === "QA" ? "Please enter Qatari ID" : "Please enter Oman ID",
                                                            pattern: {
                                                                value: addressData.country_code === "QA" ? /^\d{11}$/ : /^\d{8}$/,
                                                                message: addressData.country_code === "QA" ? "Please enter Qatari ID" : "Please enter Oman ID",
                                                            },
                                                        }}
                                                        render={({ field, fieldState: { error } }) => (
                                                            <TextField
                                                                {...field}
                                                                label={addressData.country_code === "QA" ? "Qatari ID (11-Digit)*" : "Oman ID (8-Digit)*"}
                                                                fullWidth
                                                                value={addressData.customer_unique_id || ''}
                                                                error={!!error}
                                                                helperText={error?.message}
                                                                inputProps={{
                                                                    maxLength: addressData.country_code === "QA" ? 11 : 8,
                                                                    inputMode: 'numeric',
                                                                }}
                                                                onChange={(e) => {
                                                                    const maxLength = addressData.country_code === "QA" ? 11 : 8;
                                                                    const value = e.target.value.replace(/\D/g, '').slice(0, maxLength);
                                                                    field.onChange(value);
                                                                    handleChangeform({
                                                                        target: {
                                                                            name: 'customer_unique_id',
                                                                            value,
                                                                        },
                                                                    });
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            display: 'inline-flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            margin: '10px'
                                        }}>
                                            <Box sx={{ width: '20%' }}>{'City:'}</Box>
                                            <Box sx={{ width: '50%' }}>
                                                <Controller
                                                    name='city_id'
                                                    control={control}
                                                    render={({ field }) => (

                                                        <>
                                                            <Select
                                                                {...field}
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                defaultValue={addressData.city_id === "" ? "" : addressData.city_id == 0 ? "0" : addressData.city_id}
                                                                value={addressData.city_id === "" ? "" : addressData.city_id == 0 ? "0" : addressData.city_id}
                                                                // value={addressData.city_id !== '0' ? addressData.city_id :''}
                                                                label="City"
                                                                onChange={(e) => {
                                                                    field.onChange(e);
                                                                    handleChangeform(e);
                                                                    setCitySearch("");
                                                                    setDistrictSearch("");
                                                                    setAddressData(prev => ({
                                                                        ...prev,
                                                                        district_id: '',
                                                                        district: '',
                                                                        district_id_text: ''
                                                                    }));
                                                                }}
                                                                sx={{ width: '100%', overflow: 'visible' }}
                                                                MenuProps={{ autoFocus: false, disableAutoFocusItem: true, }}>
                                                                <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                                                                    <TextField
                                                                        autoFocus
                                                                        placeholder="Search city..."
                                                                        size="small"
                                                                        fullWidth
                                                                        value={citySearch}
                                                                        onChange={(e) => setCitySearch(e.target.value)}
                                                                        onKeyDown={(e) => e.stopPropagation()}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    />
                                                                </MenuItem>
                                                                {cityMenuItems}
                                                            </Select>
                                                            {(addressData.city_id == '0' || addressData.city_id == 0) && addressData.city_id !== "" && (
                                                                <TextField
                                                                    name='city_id_text'
                                                                    placeholder='Enter City Name'
                                                                    defaultValue={addressData.city_id == 0 ? addressData.city_id_text : null}
                                                                    value={addressData.city_id == 0 ? addressData.city_id_text : null}
                                                                    onChange={(e) => {
                                                                        field.onChange(e);
                                                                        handleChangeform(e);
                                                                    }}
                                                                    fullWidth
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            display: 'inline-flex',
                                            width: '100%',
                                            alignItems: 'center',
                                            margin: '10px'
                                        }}>
                                            <Box sx={{ width: '20%' }}>{'District:'}</Box>
                                            <Box sx={{ width: '50%' }}>
                                                <Controller
                                                    name='district_id'
                                                    control={control}
                                                    render={({ field }) => (

                                                        <>
                                                            <Select
                                                                {...field}
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                defaultValue={addressData.district_id === "" ? "" : addressData.district_id == 0 ? "0" : addressData.district_id}
                                                                value={addressData.district_id === "" ? "" : addressData.district_id == 0 ? "0" : addressData.district_id}
                                                                label="District"
                                                                onChange={(e) => {
                                                                    field.onChange(e);
                                                                    handleChangeform(e);
                                                                    setDistrictSearch("");

                                                                }}
                                                                sx={{ width: '100%', overflow: 'visible' }}
                                                                MenuProps={{ autoFocus: false, disableAutoFocusItem: true, }}
                                                            >
                                                                <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                                                                    <TextField
                                                                        autoFocus
                                                                        placeholder="Search district..."
                                                                        size="small"
                                                                        fullWidth
                                                                        value={districtSearch}
                                                                        onChange={(e) => setDistrictSearch(e.target.value)}
                                                                        onKeyDown={(e) => e.stopPropagation()}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    />
                                                                </MenuItem>
                                                                {filteredDistrictList.length > 0
                                                                    ? districtMenuItems
                                                                    : addressData.city_id && addressData.city_id !== '0'
                                                                        ? [<MenuItem key="other-district" value="0">Others</MenuItem>]
                                                                        : []}

                                                            </Select>
                                                            {(addressData.district_id == '0' || addressData.district_id == 0) && addressData.district_id !== "" && (
                                                                <TextField
                                                                    name='district_id_text'
                                                                    placeholder='Enter District Name'
                                                                    // defaultValue={"Enter district name"}
                                                                    defaultValue={addressData.district_id == 0 ? addressData.district_id_text : null}
                                                                    value={addressData.district_id == 0 ? addressData.district_id_text : null}
                                                                    // value={addressData.district_id ==0 ? addressData.district : null}
                                                                    // onChange={(e) => handleChangeform(e)}
                                                                    onChange={(e) => {
                                                                        field.onChange(e);
                                                                        handleChangeform(e);
                                                                    }}
                                                                    fullWidth
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                />
                                            </Box>
                                        </Box>
                                        {addressData.country_code === 'SA' && (
                                            <Controller
                                                name="premisesCode"
                                                control={control}
                                                rules={{
                                                    required: 'Please enter a valid National Address Short Code',
                                                    minLength: {
                                                        value: 8,
                                                        message: 'Premises Code must be at least 8 characters'
                                                    }
                                                }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <TextField
                                                        {...field}
                                                        label="National Address Short Code*"
                                                        fullWidth
                                                        value={addressData.premisesCode || ''}
                                                        inputProps={{ maxLength: 8 }} // <-- blocks user typing more than 8 chars
                                                        onChange={(e) => {
                                                            field.onChange(e.target.value);
                                                            handleChangeform(e);
                                                        }}
                                                        helperText={error?.message}
                                                    />
                                                )}
                                            />
                                        )}
                                        <Controller
                                            name='postcode'
                                            control={control}
                                            //rules={{ required: true}}
                                            rules={{
                                                required: "Zip/Postal Code is required"
                                            }}
                                            render={({ field }) => <TextField
                                                inputProps={{
                                                    maxLength: 10,
                                                    pattern: "[0-9]*",
                                                }}
                                                {...field}
                                                label='Zip/Postal Code' value={addressData.postcode} onChange={(e) => handleChangeform(e)} fullWidth />}
                                        />
                                        <Controller
                                            name='phone_ext'
                                            control={control}
                                            //rules={{ required: true}}
                                            render={({ field }) => <TextField {...field} label='Country Phone Ext*' value={countryPhoneExt} disabled onChange={(e) => handleChangeform(e)} fullWidth />}
                                        />
                                        <Controller
                                            name='phone'
                                            control={control}
                                            //rules={{ required: true}}
                                            render={({ field }) => <TextField {...field} label='Phone Number*' value={addressData.phone}
                                                placeholder={phonePH} onChange={(e) => handleChangeform(e)} fullWidth />}
                                        />
                                        <Controller
                                            name="sales_person_name"
                                            control={control}
                                            rules={{
                                                required: deliveryType === "storepickup"
                                                    ? false
                                                    : "Sales Person Name is required"
                                            }}
                                            render={({ field, fieldState: { error } }) => (
                                                <TextField
                                                    {...field}
                                                    label={deliveryType === "storepickup"
                                                        ? "Sales Person Name"
                                                        : "Sales Person Name*"}
                                                    placeholder="Enter Name"
                                                    fullWidth
                                                    error={!!error}
                                                    helperText={error?.message}
                                                    onFocus={handleOutsideFocus}
                                                />
                                            )}
                                        />
                                    </form>
                                </>
                            )}

                        </Grid>
                    </Grid>
                </Box>
                <Box id='addressinfo-box' sx={{ paddingTop: '50px' }}>
                    <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                        <Typography variant='h6'>
                            Payment & Shipping Information
                        </Typography>
                    </Box>
                    <Grid container spacing={5} columns={24}>
                        <Grid item xs={11}>
                            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
                                Payment Method
                            </Typography>
                            {Number(summaryData.extra_discount) === 1 && Number(summaryData.extra_discount_amount) > 0 && (
                                <Typography>addlDisc (5%): SAR {parseFloat(summaryData.extra_discount_amount).toFixed(2)}</Typography>
                            )}
                            {(reorderId != '') &&
                                <Box>
                                    <Typography>{Payment.name ? Payment.name : null}</Typography>
                                    {
                                        Payment.last4Digits &&
                                        <Typography>
                                            Last 4 digits: {Payment.last4Digits}
                                        </Typography>
                                    }
                                    <Typography>{Payment.brand ? Payment.brand : null}</Typography>
                                     
                                    <Box sx={{ marginTop: "12px" }}>
                                        <Typography
                                        variant="subtitle2"
                                        sx={{ fontWeight: 700, marginBottom: "5px" }}
                                        >
                                        Change Payment Method
                                        </Typography>

                                        <RadioGroup
                                        value={String(Payment.id || "")}
                                        onChange={handlePayment}
                                        >
                                        <FormControlLabel
                                            value={String(PAY_LATER_PAYMENT_ID)}
                                            control={<Radio />}
                                            label="Pay Later"
                                        />
                                        </RadioGroup>
                                    </Box>
                                    
                                    {Payment.brand === 'COD' ? (

                                        <RadioGroup aria-label="payment" name="freecod" value={freeCod} onChange={handleFreeCodChange}>
                                            <FormControlLabel value="0.00" control={<Radio />} label="Free COD Fee" />
                                            <FormControlLabel value="12.00" control={<Radio />} label="Apply COD Fee" />
                                        </RadioGroup>

                                    ) : Payment.name === 'Paid with Tamara' && isTamaraVisible ? (
                                        <RadioGroup
                                            aria-label="payment"
                                            name="freetamara"
                                            value={(freeTamara === '0' || parseFloat(tamaraData.fee_value).toFixed(2) !== '0.00') ? freeTamara : parseFloat(tamaraData.fee_value).toFixed(2)}
                                            onChange={handleFreeTamaraChange}
                                        >
                                            <FormControlLabel
                                                value={parseFloat(tamaraData.fee_value).toFixed(2)}
                                                control={<Radio />}
                                                label="Apply Tamara Fee"
                                            />
                                            <FormControlLabel
                                                value="0"
                                                control={<Radio />}
                                                label="Free Tamara Fee"
                                            />
                                        </RadioGroup>

                                    ) : Payment.name === 'Paid with Tabby' && isTabbyVisible ? (
                                        <RadioGroup
                                            aria-label="payment"
                                            name="freetabby"
                                            value={(freeTabby === '0' || isNaN(parseFloat(tabbyData.fee_value)) || parseFloat(tabbyData.fee_value).toFixed(2) !== '0.00') ? freeTabby : parseFloat(tabbyData.fee_value).toFixed(2)}
                                            onChange={handleFreeTabbyChange}
                                        >
                                            <FormControlLabel
                                                value={parseFloat(tabbyData.fee_value) && !isNaN(parseFloat(tabbyData.fee_value)) ? parseFloat(tabbyData.fee_value).toFixed(2) : '0.00'}
                                                control={<Radio />}
                                                label="Apply Tabby Fee"
                                            />
                                            <FormControlLabel
                                                value="0"
                                                control={<Radio />}
                                                label="Free Tabby Fee"
                                            />
                                        </RadioGroup>
                                    ) : Number(Payment.id) === PAY_LATER_PAYMENT_ID ? (
                                    <Typography sx={{ mt: 1 }}>
                                        A payment link will be sent to the customer’s email after the order is created.
                                    </Typography>
                                ) : null}

                                </Box>
                            }
                            {(reorderId == '') &&
                                <Box>
                                    <Controller
                                        name="payment_method"
                                        control={control}
                                        render={({ field }) =>
                                            <>
                                                {/*Show Bank Transfer only if order source is B2B */}

                                                <RadioGroup
                                                    {...field}
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    id="payment_method"
                                                    value={Payment.id}
                                                >
                                                    {/* {watch("admin_order_source") === 'B2B' && ( */}
                                                    {(orderHeaderData.admin_order_source === 'B2B') &&

                                                        <FormControlLabel value="7" control={<Radio />} label="Bank Transfer" onChange={handlePayment} />}
                                                    {(orderAddressCountryCode == 'SA' && !isStoresPickup) &&
                                                        <FormControlLabel value="1" control={<Radio />} label="Cash on Delivery" onChange={handlePayment} />
                                                    }
                                                    <FormControlLabel value="2" control={<Radio />} label="Credit / Debit Cards" onChange={handlePayment} />
                                                    {/* {Payment.id ==2 ?   <Box>
                                      s          <Typography>Card Number: </Typography>
                                                <Input
                                                    readOnly
                                                    type='text'
                                                    sx={{ border: '1px solid #2b3f7a', marginRight: '40px',marginBottom:'20px', padding: '0px 10px 0px', width:'350px' }}
                                                    placeholder='Card Number'  value={ data.transaction.paymentBrand == "VISA" ? Payment.last4Digits : null }
                                                />
                                                    <Typography>Transaction ID: </Typography>
                                                <Input
                                                    readOnly
                                                    type='text'
                                                    sx={{ border: '1px solid #2b3f7a', marginRight: '40px', marginBottom:'20px', padding: '0px 10px 0px', width:'350px' }}
                                                    placeholder='Transaction ID' value={  data.transaction.paymentBrand == "VISA" ? Payment.txn_id : null}
                                                />
                                            </Box> :null } */}

                                                    <FormControlLabel value="4" control={<Radio />} label="Mada" onChange={handlePayment} />
                                                    {/* { Payment.id ==4 ? <Box >
                                                <Typography>Card Number: </Typography>
                                                <Input
                                                    readOnly
                                                    type='text'
                                                    sx={{ border: '1px solid #2b3f7a', marginRight: '40px',marginBottom:'20px', padding: '0px 10px 0px', width:'350px' }}
                                                    placeholder='Card Number' value={ data.transaction.paymentBrand == "MADA" ? Payment.last4Digits : null}
                                                />
                                                    <Typography>Transaction ID: </Typography>
                                                <Input
                                                    readOnly
                                                    type='text'
                                                    sx={{ border: '1px solid #2b3f7a', marginRight: '40px', marginBottom:'20px', padding: '0px 10px 0px', width:'350px' }}
                                                    placeholder='Transaction ID'  value={ data.transaction.paymentBrand == "MADA" ? Payment.txn_id : null}
                                                />
                                            </Box> : null } */}
                                                    {(orderAddressCountryCode == 'SA' && showTamara && isTamaraActive) && (
                                                        <FormControlLabel value="5" control={<Radio />} label="Tamara" onChange={handlePayment} />
                                                    )}
                                                    {(orderAddressCountryCode == 'SA' && showTabby && isTabbyActive) && (
                                                        <FormControlLabel value="6" control={<Radio />} label="Tabby" onChange={handlePayment} />
                                                    )}
                                                     
                                                    <FormControlLabel
                                                        value={String(PAY_LATER_PAYMENT_ID)}
                                                        control={<Radio />}
                                                        label="Pay Later"
                                                        onChange={handlePayment}
                                                    />
                                              
                                                    {/* { Payment.id ==5 ? <Box >
                                                <Typography>Payment Type: </Typography>
                                                <Input
                                                    readOnly
                                                    type='text'
                                                    sx={{ border: '1px solid #2b3f7a', marginRight: '40px',marginBottom:'20px', padding: '0px 10px 0px', width:'350px' }}
                                                    placeholder='Payment Type' value={ data.transaction.paymentBrand == "TAMARA" ? Payment.last4Digits : null}
                                                />
                                            </Box> : null } */}

                                                </RadioGroup>

                                            </>
                                        }
                                    />
                                </Box>
                            }
                        </Grid>
                        <Grid item xs={11}>
                            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
                                Shipping Method
                            </Typography>

                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                // defaultValue={shipMethod}
                                id="shipping_method"
                                name="shipping_charges"
                                value={shipMethod}
                                onChange={handleShippingMethodChange}
                            >

                                {deliveryType === "storepickup" ? (

                                    <FormControlLabel
                                        value="freeshipping"
                                        control={<Radio />}
                                        label="Free Shipping"
                                        onChange={handleShippingMethod}
                                    />

                                ) : (

                                    <>
                                        {/* Free Shipping */}
                                        <FormControlLabel
                                            value="freeshipping"
                                            control={<Radio />}
                                            label="Free Shipping"
                                            onChange={handleShippingMethod}
                                        />

                                        {/* Saudi Shipping */}
                                        {orderAddressCountryCode === "SA" && (
                                            <FormControlLabel
                                                value="shababuna"
                                                control={<Radio />}
                                                label="Shababuna Shipping - 23 SAR"
                                                onChange={handleShippingMethod}
                                            />
                                        )}

                                        {/* International Shipping */}
                                        {orderAddressCountryCode !== "SA" && (
                                            <FormControlLabel
                                                value="international"
                                                control={<Radio />}
                                                label="International Shipping"
                                                onChange={(event) => {
                                                    handleShippingMethod(event);
                                                    setAddShippingCharges("");
                                                    setIsEditingShipping(false);
                                                }}
                                            />
                                        )}
                                    </>

                                )}

                                {/* International Shipping option with conditional input */}

                                {/* {orderAddressCountryCode !== "SA" && (
                                    <>
                                        <FormControlLabel
                                            value="international"
                                            control={<Radio />}
                                            label="International Shipping"
                                            onChange={(event) => {
                                                handleShippingMethod(event); // Handle radio button change logic
                                                setAddShippingCharges(""); // Reset shipping charges
                                                setIsEditingShipping(false); // Reset editing state
                                            }}                                        /> */}
                                {/* {isEditingShipping && ( */}
                                {/* {showShippingInput && (

                                            <TextField
                                                label="Enter Shipping Charges"
                                                placeholder="Enter value"
                                                value={addShippingCharges}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value.replace(/[^0-9]/g, ""); 
                                                    if (/^\d{0,8}$/.test(inputValue)) { 
                                                        setAddShippingCharges(inputValue);
                                                    }
                                                }}
                                                onBlur={() => {
                                                    if (addShippingCharges && !isNaN(parseFloat(addShippingCharges))) {
                                                        updateShippingCharges(parseFloat(addShippingCharges)); // Save the value
                                                        setIsEditingShipping(false); // Exit editing state
                                                    } else {
                                                        // Keep the input in focus if the value is invalid or empty
                                                        setIsEditingShipping(true); // Ensure editing state persists
                                                    }
                                                }}
                                                helperText={
                                                    !addShippingCharges || isNaN(parseFloat(addShippingCharges))
                                                        ? "Shipping charges are required (max 8 digits)."
                                                        : ""
                                                }
                                                error={!addShippingCharges || isNaN(parseFloat(addShippingCharges))} // Show error if value is invalid
                                                inputProps={{
                                                    inputMode: "numeric",
                                                    maxLength: 8,
                                                }}
                                                sx={{
                                                    width: "50%", // Set half-width
                                                }}                                            />
                                        )} */}
                                {/* </>
                                )} */}
                            </RadioGroup>
                            {!isB2BOrder && deliveryType !== "storepickup" && (

                                <Box sx={{ mt: 3 }}>
                                    {canShowNextDay && (

                                        <>
                                            <Typography>Next Day Delivery</Typography>

                                            <RadioGroup
                                                value={nextDayDelivery}
                                                // onChange={async (e) => {
                                                //     const value = e.target.value;
                                                //     if (value === "Yes") {
                                                //         try {
                                                //             const stockResult = await validateNextDayStock(addressData.city, orderItemsData);
                                                //             if (!stockResult.success) {
                                                //                 handleAlertGen(getStockErrorMessage(stockResult));
                                                //                 return;
                                                //             }
                                                //         } catch (error) {
                                                //             handleAlertGen(error.response?.data?.message || 'Unable to verify NDD stock. Please try again.');
                                                //             return;
                                                //         }
                                                //     }
                                                //     setNextDayDelivery(value);
                                                //     syncDeliverySelection(deliveryType, value);
                                                // }}
                                                onChange={async (e) => {
                                                    const value = e.target.value;
                                                    if (value === "Yes") {
                                                        // Keep NDD disabled until the exact submit items pass
                                                        // the same stock validation used during order creation.
                                                        setNddSelectedStores([]);
                                                        syncDeliverySelection("delivery", "No");

                                                        const stockResult = await validateNextDayStock(
                                                            addressData.city,
                                                            orderItemsData
                                                        );
                                                        if (!stockResult.success) {
                                                            showStockDialog(stockResult, "ndd", addressData.city);
                                                            return;
                                                        }

                                                        const allocations = normalizeStoreAllocations(
                                                            stockResult.selectedStore || []
                                                        );
                                                        if (!allocations.length) {
                                                            showStockDialog({
                                                                ...stockResult,
                                                                success: false,
                                                                message: "No valid NDD store allocation was returned."
                                                            }, "ndd", addressData.city);
                                                            return;
                                                        }

                                                        setNddSelectedStores(allocations);
                                                        showStockDialog(stockResult, "ndd", addressData.city);
                                                        syncDeliverySelection("delivery", "Yes");
                                                    } else {
                                                        setNddSelectedStores([]);
                                                        syncDeliverySelection("delivery", "No");
                                                    }
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={<Radio />}
                                                    label="Yes"
                                                    disabled={!canShowNextDay}

                                                />

                                                <FormControlLabel
                                                    value="No"
                                                    control={<Radio />}
                                                    label="No"
                                                />
                                            </RadioGroup>
                                        </>

                                    )}
                                </Box>
                            )}
                            {summaryData?.admin_order_source === "B2B" && (

                                <form>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={6}>
                                            <Typography sx={{ marginTop: '20px', fontWeight: 'bold' }}>Purchase Order </Typography>
                                            {/* HIDDEN FIELD – drives the dynamic label */}
                                            <Controller
                                                name="id_label"
                                                control={control}
                                                defaultValue={summaryData?.id_label || "VAT / CR / Other Number"}
                                                render={() => null}
                                            />

                                            <Controller
                                                name='po_number'
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField {...field} label="PO Number" value={field.value ?? ""} onChange={(e) => { field.onChange(e); handlePurchaseOrder(e); }}
                                                        fullWidth
                                                    />
                                                )}
                                            />

                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography sx={{ marginTop: '20px', fontWeight: 'bold' }}>{watch("id_label") || "VAT / CR / Other Number"}</Typography>
                                            <Controller
                                                name='vat_number'
                                                control={control}
                                                render={({ field }) => (
                                                    <TextField {...field}
                                                        label={watch("id_label") || "VAT / CR / Other Number"}
                                                        value={field.value ?? ""}
                                                        onChange={(e) => { field.onChange(e); handleVatNumber(e); }}
                                                        fullWidth
                                                    />
                                                )}
                                            />

                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <Box id='totalinfo-box' sx={{ paddingTop: '50px', marginBottom: '50px' }}>
                    <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                        <Typography variant='h6'> Order Total </Typography>
                    </Box>
                    <Grid container spacing={5} columns={24} >

                        <Grid item xs={12}>
                            {(reorderId != '') ?
                                <Box>
                                    <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
                                        Remarks*
                                    </Typography>
                                    <TextField
                                        placeholder="Please add remarks here"
                                        multiline
                                        rows={4}
                                        maxRows={10}
                                        style={{ width: '80%', height: '40px' }}
                                        onChange={(e) => setRemarksString(e.target.value)}
                                    />
                                </Box>
                                :
                                <Box>

                                    <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700 }}>
                                        Notes*
                                    </Typography>
                                    {orderHeaderData?.admin_order_source === "B2B" && (

                                        // {orderHeaderData?.admin_order_source === "B2B" && (
                                        <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 700 }}>
                                            Channel : B2B
                                        </Typography>
                                    )}

                                    {orderHeaderData?.admin_order_source === "Shababuna" && (
                                        <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 700 }}>
                                            Channel : Shababuna
                                        </Typography>
                                    )}

                                    <TextareaAutosize
                                        aria-label="minimum height"
                                        onFocus={handleOutsideFocus}
                                        minRows={5}
                                        placeholder='Please add Notes here (max 255 characters)'
                                        value={orderHeaderData.notes?.replace(/^B2B: |^Shababuna: /, "") || ""}

                                        onChange={handleNotes}
                                        style={{
                                            width: 500,
                                            maxWidth: '100%',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </Box>
                            }
                        </Grid>


                        <Grid item xs={11}>
                            <Typography variant='subtitle1' sx={{ fontsize: '1rem', fontWeight: 700, paddingBottom: '20px' }}>
                                Order Totals
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Subtotal (incl. Tax)</Typography>
                                <Typography>SAR {parseFloat(summaryData.subtotalInclTax).toFixed(2)} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Tax</Typography>
                                <Typography>SAR {parseFloat(summaryData.taxAmount).toFixed(2)} </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Coupon Discount</Typography>
                                <Typography>SAR {parseFloat(summaryData.discountAmount).toFixed(2)}</Typography>
                            </Box>
                            {Number(summaryData.extra_discount) === 1 && Number(summaryData.extra_discount_amount) > 0 && (
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                    <Typography>addlDisc (5%)</Typography>
                                    <Typography>SAR {parseFloat(summaryData.extra_discount_amount).toFixed(2)}</Typography>
                                </Box>
                            )}

                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Shipping & Handling</Typography>
                                <Typography>SAR {parseFloat(summaryData.shippingInclTax).toFixed(2)} </Typography>
                            </Box>
                            {parseFloat(summaryData.one_day_delivery_charge || 0) > 0 && (
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                    <Typography>Next Day Delivery Fee</Typography>
                                    <Typography>SAR {parseFloat(summaryData.one_day_delivery_charge).toFixed(2)} </Typography>
                                </Box>
                            )}
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Cash on Delivery Fee (incl. Tax)</Typography>
                                <Typography>SAR {parseFloat(summaryData.codFeeInclTax).toFixed(2)} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Tamara Processing Fee</Typography>
                                <Typography>SAR {parseFloat(summaryData.tamaraProcessingFee).toFixed(2)} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Tabby Processing Fee</Typography>
                                <Typography>SAR {isNaN(parseFloat(summaryData.tabbyProcessingFee)) ? '0.00' : parseFloat(summaryData.tabbyProcessingFee).toFixed(2)}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Grand Total</Typography>
                                <Typography>    SAR {isNaN(parseFloat(summaryData?.grandTotal)) ? '0.00' : parseFloat(summaryData.grandTotal).toFixed(2)}
                                </Typography>
                            </Box>
                            {/* <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Total Paid</Typography>
                                <Typography>SAR {data.summary.total_paid ? parseFloat(data.summary.total_paid).toFixed(2) : (0.00).toFixed(2)} </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Total Refunded</Typography>
                                <Typography>SAR {data.summary.total_refunded ? parseFloat(data.summary.total_refunded).toFixed(2) : (0.00).toFixed(2)}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', '& .MuiTypography-root': { fontSize: '16px', fontWeight: 600 } }}>
                                <Typography>Total Due</Typography>
                                <Typography>SAR {data.summary.total_due ? parseFloat(data.summary.total_due).toFixed(2) : (0.00).toFixed(2)} </Typography>
                            </Box> */}
                        </Grid>
                    </Grid>


                </Box>


            </Box>

        </Box>
    )

}

export default OrderCreate;
